// Material Dashboard 2 React components
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";

const requestHeaderTableData = {
  columns: [
    { Header: "S/N", accessor: "num", align: "left", width: "5%" },
    { Header: "Key", accessor: "key", align: "left", width: "10%" },
    { Header: "Value", accessor: "value", align: "left" },
  ],
  rows: [
    {
      num: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          1
        </MDTypography>
      ),
      key: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          Authorization
        </MDTypography>
      ),
      value: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          {"Bearer <access_token>"}
        </MDTypography>
      ),
    },
  ],
};

let accountOpeningApiData = {
  General_Data: {
    children: [
      {
        generalMainHeading: "Introduction",
        mainGridId: "introduction",
        generalDescOne:
          "The API is designed to ensure that the account opening process is as easy as possible. Please follow the guidelines of the API, and in case of any questions, please contact relevant personnel within VCT Technologies LLC.",
        generalDescTwo: [
          {
            valOne:
              "This document should be utilized by customers/clients/users while designing their solutions.",
          },
        ],
      },
      {
        generalMainHeading: "Environment",
        mainGridId: "environment",
        generalDescWithLinkOne: {
          desc: "The UAT environment base URL is:",
          link: "https://ao-api.vcttech.co/",
        },
        generalDescWithLinkTwo: {
          desc: "The UAT swagger documentation URL is:",
          link: "https://ao-api.vcttech.co/swagger/index.html",
        },
      },
      {
        generalMainHeading: "The Flow of Account Opening APIs",
        mainGridId: "the-flow-of-account-opening-apis",
        generalDescOne:
          "The Account Opening APIs, in terms of data gathering, consist of two types of flows depending upon the type of the application:",
        generalList: [
          "Company / Organization / LLC flow",
          "Individual User (IU) Flow and Joint Account (JA) Flow",
        ],
        generalDescTwo: [
          {
            valOne:
              "Each flow has a different set of APIs that need to be called for a successful account opening process. Further information about each flow is given below.",
          },
        ],
      },
      {
        generalMainHeading: "Company / Organization / LLC Flow",
        mainGridId: "company-organization-llcflow",
        generalDescOne: "This flow consists of the following APIs:",
        generalListWithLink: [
          {
            id: "token-connect-login-url",
            value: "Login API",
          },
          {
            id: "iu-ja-signup-initial-information-api",
            value: "Company Initial Information API",
          },
          {
            id: "company-beneficiary-user-information-api",
            value: "Company Beneficiary User Information API",
          },
          {
            id: "company-account-funding-api",
            value: "Company Account Funding API",
          },
          {
            id: "company-other-data-api",
            value: "Company Other Data API",
          },
          {
            id: "company-update-api",
            value: "Company Update API",
          },
          {
            id: "company-otp-api",
            value: "Company OTP API",
          },
        ],
        generalDescTwo: [
          {
            valOne:
              "The process of calling these APIs is described in Diagram 1. The AO User in the diagram represents the Account Opening user, referred to as “users” in the document. Before calling these APIs, the users must get a Bearer Token, a public key, an AES key, and an IV from the",
            linkOneDesc: "Login API.",
            linkOne: "token-connect-login-url",
            valTwo:
              "All the data sent to these APIs is encrypted using the RSA algorithm with a 1024-bit key size except any binary data or files; the binary data or files are encrypted using the AES algorithm with a 256-bit key size.Further instructions on how to encrypt the data can be found",
            linkTwoDesc: "here.",
            linkTwo: "here.",
          },
        ],
        generalDescThree:
          "To call these APIs, the users must call the Company Initial Information API with the encrypted required data. This API returns a company ID on the successful completion of the request. This company ID is used to enter further data into the system and associate that data with the company. After the Initial Information API, the user can call the Beneficiary User Information API, Company Account Funding API, and Company Other Data API using the company ID that was created previously.",
        image: true,
        imageDesc:
          "Diagram 1: The Flow of calling Company/Organization/LLC Account Opening APIs",
      },
      {
        generalMainHeading: "Individual User Flow and Joint Account Flow",
        mainGridId: "individual-user-flow-and-joint-account-flow",
        generalDescOne:
          "The Individual User (IU) and Joint Account (JA) flows consist of the following APIs:",
        generalListWithLink: [
          {
            id: "token-connect-login-url",
            value: "Login API",
          },
          {
            id: "iu-ja-signup-initial-information-api",
            value: "IU/JA Signup Initial Information API",
          },
          {
            id: "iu-ja-signup-account-funding-api",
            value: "IU/JA Signup Account Funding API",
          },
          {
            id: "iu-ja-signup-other-data-api",
            value: "IU/JA Signup Other Data API",
          },
          {
            id: "iu-ja-signup-update-api",
            value: "IU/JA Signup Update API",
          },
          {
            id: "iu-ja-signup-otp-api",
            value: "IU/JA Signup OTP API",
          },
          {
            id: "iu-ja-all-accounts-api",
            value: "IU/JA All Accounts API",
          },
          {
            id: "iu-ja-filter-accounts-api",
            value: "IU/JA Filter Accounts API",
          },
        ],
        generalDescTwo: [
          {
            valOne:
              "IU and JA flows are similar and can follow the same set of APIs. The process of calling these APIs is described in Diagram 2. The only thing that separates IU and JA is the data field “ApplicationAccountType” in the Signup Initial Information API. LikeCompany/Organization/LLC Flow, before calling IU and JA APIs, the users must get a Bearer Token, a public key, an AES key, and an IV from the",
            linkOneDesc: "Login API.",
            linkOne: "token-connect-login-url",
            valTwo:
              "All the data that is sent to these APIs is encrypted using the RSA algorithm with a 1024-bit key size except any binary data or files; the binary data or files are encrypted using the AES algorithm with a 256-bit key size.Further instructions on how to encrypt the data can be found",
            linkTwoDesc: "here.",
            linkTwo: "here.",
            linkThreeDesc:
              "The process of calling these APIs begins with the Signup Initial Information API, with the encrypted required data. After successfully completing the request, it returns with a unique User Identification Code. This code indicates the users' identification in the system, and it is later used to call further APIs. After the Initial Information API, users can call Signup.",
            linkFourDesc:
              "Account Funding API and Signup Other Data API using the User Identification Code that was created previously.",
          },
        ],
        generalDescThree:
          "To call these APIs, the users must call the Company Initial Information API with the encrypted required data. This API returns a company ID on the successful completion of the request. This company ID is used to enter further data into the system and associate that data with the company. After the Initial Information API, the user can call the Beneficiary User Information API, Company Account Funding API, and Company Other Data API using the company ID that was created previously.",
        imageTwo: true,
        imageDesc:
          "Diagram 2: The Flow of calling IU and JA Account Opening APIs",
      },
      {
        oaf: true,
        generalMainHeading: "Overall Application Flow",
        mainGridId: "overall-application-flow",
        generalDescOneOaf:
          "The overall flow of the APIs and the status of the application is described in Diagram 3:",
        generalDescTwoOaf:
          "As shown in the diagram, users can pick the Company/Organization/LLC flow or IU/JA flow depending on the requirement. When users call any of the Initial Information APIs, a new application request is generated in the system with the application status set to DRAFT. This status remains the same until the flow is completed and the users call the Other Data API respective to that flow. When users call the Other Data API, the status of the application will automatically change from DRAFT to PENDING.",
        generalDescThreeOaf:
          "When the application status changes to PENDING, the admin can either APPROVE, REJECT, or return the application to DRAFT depending on the data sent by the users. The three following scenarios can happen:",
        generalListOaf: [
          "APPROVED: When an application is approved, an email will be sent to notify the respective user of the successful creation of their account. That email will also contain the account numbers generated during the approval process.",
          "REJECTED: When the application is rejected, the status will be updated to REJECT, and no accounts will be created for that application.",
          "DRAFT: If the application status is set to DRAFT by the admin, the users have a chance to follow the flow, complete it, and submit the application again. After that, the status is updated to PENDING again for the admin to review.",
        ],
        imageThreeOaf: true,
        imageDescOaf: "Diagram 3: Application flow",
      },
      {
        apiSpec: true,
        apiSpecMainHeading: "API Specifications",
        mainGridId: "api-specifications",
        generalDescOne:
          "There are many APIs other than the above-mentioned APIs, which are not part of a specific flow but aid in the process of Account Opening. They are divided into different groups. These groups with the specific APIs, plus the details of the above-mentioned APIs are listed below:",
        generalListTitleWithLink: [
          {
            title:
              "Token Connect (For both Company/Organization/LLC and IU/JA flows)",
            child: [{ id: "token-connect-login-url", value: "Login API" }],
          },
          {
            title: "Company/Organization/LLC APIs",
            child: [
              {
                id: "iu-ja-signup-initial-information-api",
                value: "Company Initial Information API",
              },
              {
                id: "company-initial-information-api",
                value: "Company Beneficiary User Information API",
              },
              {
                id: "company-account-funding-api",
                value: "Company Account Funding API",
              },
              {
                id: "company-other-data-api",
                value: "Company Other Data API",
              },
              {
                id: "company-update-api-route-url",
                value: "Company Update API",
              },
              {
                id: "company-otp-api-route-url",
                value: "Company OTP API",
              },
            ],
          },
          {
            title: "Individual User (IU)/Join Account (JU) (Signup) APIs",
            child: [
              {
                id: "token-connect-login-url",
                value: "Login API",
              },
              {
                id: "iu-ja-signup-initial-information-api",
                value: "IU/JA Signup Initial Information API",
              },
              {
                id: "iu-ja-signup-account-funding-api",
                value: "IU/JA Signup Account Funding API",
              },
              {
                id: "iu-ja-signup-other-data-api",
                value: "IU/JA Signup Other Data API",
              },
              {
                id: "iu-ja-signup-update-api",
                value: "IU/JA Signup Update API",
              },
              {
                id: "iu-ja-signup-otp-api",
                value: "IU/JA Signup OTP API",
              },
              {
                id: "iu-ja-all-accounts-api",
                value: "IU/JA All Accounts API",
              },
              {
                id: "iu-ja-filter-accounts-api",
                value: "IU/JA Filter Accounts API",
              },
            ],
          },
          {
            title: "Disclosure Documents APIs",
            child: [
              {
                id: "documents-list-all-route-url",
                value: "List All",
              },
              {
                id: "get-specific-documents-list-all-route-url",
                value: "Get Specific Document",
              },
            ],
          },
          {
            title: "API Options",
            child: [
              {
                id: "api-opt-documents-list-all-route-url",
                value: "List All",
              },
              {
                id: "api-opt-get-specific-document-route-url",
                value: "Get Option Details",
              },
            ],
          },
        ],
      },
    ],
  },

  // Token_Connect data
  Token_Connect: {
    children: [
      {
        // parentId:"token-connect",
        mainHeading:
          "Token Connect (For Company/Organization/LLC and IU/JA flows)",
        mainGridId: "token-connect",
        routeUrlId: "token-connect-login-url",
        dataFeildId: "token-connect-route-url",
        subHeading: "Login API",
        subHeadingDesc:
          "The Login API provides a user authentication bearer token, a public key, an AES key, and an IV for encrypted data fields. The route URL and specifications for the Login API are as follows: ",
        endPointHeading: "Request Endpoint",
        endPointDesc: "<base URL>/connect/token",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the Login API is as follows:",
        requestHeaderTable: requestHeaderTableData,
        otherData: {
          authorization: "<BASE64[ClientId:ClientSecret]>",
          contentType: "application/x-www-form-urlencoded",
          body: "client_credentials",
        },
        respObjKey: "login_account_opening",
      },
    ],
  },

  // Company Data
  Company: {
    children: [
      {
        parentid: "company-organization-llcapis",
        mainHeading: "Company/Organization/LLC APIs",
        mainGridId: "company-initial-information-api",
        routeUrlId: "initial-information-api-route-url",
        dataFeildId: "initial-information-api-data-fields",
        subHeading: "Company Initial Information API",
        endPointHeading: "Request Endpoint",
        endPointDesc: "<base URL>/API/v1/company/initial",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the Company Initial Information API is as follows:",
        requestHeaderTable: requestHeaderTableData,
        dataFieldHeading: "Data Fields",
        dataFieldDesc:
          "The Company Initial Information API can be called by providing the data fields in the form-data body of the request. Each field must be encrypted and follow the validations for the request to be completed successfully.",
        updateRequestTitle:
          "Update Request of Company Initial Information API ",
        updateRequestDes:
          "The Company Initial Information API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, users must send the “CompanyID” data field with the other data fields. This Company ID refers to the company whose data needs to be updated. ",
        dataFieldTable: {
          columns: [
            {
              Header: "Field Name",
              accessor: "fieldName",
              align: "left",
              width: "5%",
            },
            { Header: "", accessor: "dataType", align: "left", width: "10%" },
            { Header: "Comments", accessor: "comments", align: "left" },
          ],
          rows: [
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  CompanyId
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  To update the data of an already created company, enter an
                  already created CompanyId. This is only possible if the
                  application is not yet completed.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  CompanyName<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Name of the company /<br /> organization / LLC
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  CompanyAddress<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Address of the company
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AptOrSuite
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(5)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Apartment or suite where the company is located.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Country<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Country where the company is located currently. (Should be in
                  ISO 2 format)
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  State
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  State of the country where the company is located. <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If Country
                  = USA or CAN
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  City<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), <br />
                    RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  The current city where the company is located.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ZipCode
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(5)"XXXXX" for USA & <br /> StringLength(7) "XXX
                    XXX" for CAN
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Zip code of the area where the company is located
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If Country
                  = USA or CAN
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  PhoneNumber<span style={{ color: "#ff4848" }}>*</span> <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(11), <br />
                    RegularExpression(@"\(?\d{3}\)?-? *\d{3}-? *-?\d{4}")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Current phone number of the company or authorized personnel
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Email<span style={{ color: "#ff4848" }}>*</span> <br />
                  <span style={{ color: "#999999" }}>
                    Should be in email format
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Email of the company or the authorized personnel
                  (JohnDoe@exampleDomain.com)
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TaxIdNum
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(9) for USA and StringLength(11) for the Non
                    Resident of USA
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              fieldValidations: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  StringLength(9) for USA
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Tax Id number of the company
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>NOT Required: </span> If
                  TaxIdType = APT
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IsMailingAddressDifferent
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  If there is different mailing
                  <br /> address. Default value = False
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MACompanyAddress
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Mailing address of the company, in case of a different Mailing
                  Address.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MAAptOrSuite
                  <br />
                  <span style={{ color: "#999999" }}> StringLength(5)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Apartment or suite of mailing address
                  <br />
                  <br />
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MACity
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    StringLength(50), <br />
                    RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  City of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MAZipCode
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    StringLength(10), <br />
                    RegularExpression(@"^[0-9a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Zip code of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MACountry
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Country of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MAState
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  State of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  InvestmentRiskTolerance
                  <span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Value for investment risk tolerance i.e
                  <br /> 1 = Conservative, <br />2 = Moderately Conservative,{" "}
                  <br />3 = Moderate, <br />4 = Moderately Aggressive, <br />5 =
                  Significant Risk
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IdentificationProofType
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Value for Identification Proof Type <br /> i.e 1 = Government
                  issued ID,
                  <br /> 2 = Utility bill & Passport
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Front<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    1KB - 8MB,Allowed formats = ".jpeg", ".jpg", ".png"
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Base64 Encoded Front side image of the Identification proof
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Back<span style={{ color: "#ff4848" }}>*</span> <br />
                  <span style={{ color: "#999999" }}>
                    1KB - 8MB, ValidateExpectedValues{" "}
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Base64 Encoded Back side image of the Identification proof.
                  Allowed formats of Back in case of IdentificationProofType=1
                  will be
                  <ul>
                    <li>".jpeg",</li> <li>".jpg",</li>
                    <li>".png"</li>
                  </ul>{" "}
                  While, for IdentificationProofType=2, the allowed formats of
                  Back would be{" "}
                  <ul>
                    <li>".pdf"</li>
                  </ul>
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IssuingCountry<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  The country which issued Identification proof (Should be in
                  ISO 2 format)
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IssuingState<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  State of the country, which issued Identification proof
                  (Should be in ISO 2 format)
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  CorporateDocumentOne
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    1KB - 8MB,Allowed formats = ".jpeg", ".jpg", ".png" ,".pdf"{" "}
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  In addition to the ID, Base64 Encoded Article of
                  Incorporation, Certificate of Incorporation, Articles of
                  Organization, and Certification of Beneficial Ownership. (If
                  foreign please submit W8 BEN-E)
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  CorporateDocumentTwo
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    1KB - 8MB,Allowed formats = ".jpeg", ".jpg", ".png" ,".pdf"{" "}
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  In addition to the ID, Base64 Encoded Article of
                  Incorporation, Certificate of Incorporation, Articles of
                  Organization, and Certification of Beneficial Ownership. (If
                  foreign please submit W8 BEN-E)
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  CorporateDocumentThree
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    1KB - 8MB,Allowed formats = ".jpeg", ".jpg", ".png" ,".pdf"{" "}
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  In addition to the ID, Base64 Encoded Article of
                  Incorporation, Certificate of Incorporation, Articles of
                  Organization, and Certification of Beneficial Ownership. (If
                  foreign please submit W8 BEN-E)
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  CorporateDocumentFour
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    1KB - 8MB,Allowed formats = ".jpeg", ".jpg", ".png" ,".pdf"{" "}
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  In addition to the ID, Base64 Encoded Article of
                  Incorporation, Certificate of Incorporation, Articles of
                  Organization, and Certification of Beneficial Ownership. (If
                  foreign please submit W8 BEN-E)
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AccountTypes<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    StringLength(2), RegularExpression("MC|CM|C|M"){" "}
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  M = margin,
                  <br /> C = cash,
                  <br /> CM = cash&margin,, <br />
                  CM= cash&margin,
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  UserSignature
                  <br />
                  <span style={{ color: "#999999" }}>
                    1KB - 8MB, Allowed formats = ".jpeg", ".jpg", ".png"{" "}
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Base64 Encoded Image of the user signature
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  GroupCode
                  <br />
                  <span style={{ color: "#999999" }}>
                    ValidateExpectedValues{" "}
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  GroupCode of the firm for InteliClear. Expected Values:
                  retrieve from GET {"<base URL>"}
                  /API/v1/ApiOptions/Details?optionName=GroupCode
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TaxIdType<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    ValidateExpectedValues{" "}
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  ExpectedValues = EIN, ITN, SSN, TIN, APT
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ForeignIdType
                  <br />
                  <span style={{ color: "#999999" }}>
                    ValidateExpectedValues{" "}
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  ExpectedValues = SSN, TIN, FTN, GIIN
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If Issuing
                  Country != USA
                </MDTypography>
              ),
            },
          ],
        },
        otherData: {
          // heading: "Update Request of Company Initial Information API",
          // desc: 'This API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, the user must send the "CompanyID" data field with the other data fields. This Company ID refers to the company whose data needs to be updated.',
        },
        // respObjKey: "companyInitialRouteUrl"
      },
      {
        mainGridId: "company-beneficiary-user-information-api",
        routeUrlId: "beneficiary-user-information-api-route-url",
        dataFeildId: "beneficiary-user-information-api-data-fields",
        subHeading: "Company Beneficiary User Information API",
        subHeadingDesc:
          "The Company/Organization/LLC flow requires a company beneficiary user to be added to the system through this API. A company can have up to five beneficiary users, but at least one is required to complete the flow. The Company Beneficiary User Information API can be called many times to add new beneficiary users to the system. On successful completion, this API will return the user ID of the newly created beneficiary user. ",
        endPointHeading: "Request Endpoint",
        endPointDesc: "<base URL>/API/v1/signup/initial",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the Beneficiary User Information API is as follows:",
        requestHeaderTable: requestHeaderTableData,
        dataFieldHeading: "Data Fields",
        dataFieldDesc:
          "The Beneficiary User Information API can be called by providing the data fields in the form-data body of the request. Each field must be encrypted and follow the validations for the request to be completed successfully. For a beneficiary user, the data field “IsBusinessEntity” must be set to true, and a company ID provided to associate this beneficiary user with the respective company. ",
        updateRequestTitle:
          "Update Request of Beneficiary User Information API ",
        updateRequestDes:
          "This Beneficiary User Information API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, users must send the “CompanyID” and the “UserIdentifierCode” data fields with the other data fields. This company ID and user ID refer to the company and the beneficiary user whose data needs to be updated. ",
        dataFieldTable: {
          columns: [
            {
              Header: "Field Name",
              accessor: "fieldName",
              align: "left",
              width: "15%",
            },
            { Header: "", accessor: "dataType", align: "center", width: "5%" },
            { Header: "Comments", accessor: "comments", align: "left" },
          ],
          rows: [
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  UserIdentifierCode
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  To update the data of an already created user, enter an
                  already created UserIdentifierCode. This is only possible if
                  the application is not yet completed.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IsBusinessEntity
                  <br />
                  <span style={{ color: "#999999" }}>
                    Must be TRUE for adding a beneficiary user
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  If the data entered belongs to an organization or LLC. Default
                  value = False. Must be set to True for the beneficiary user.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ApplicationAccountType
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  The type of account that needs to be opened. Expected values:
                  [ "INDIV", "JCP", "JROS", "JTE", "JTIC", "LLC"]
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  CompanyId
                  <br />
                  <span style={{ color: "#999999" }}>
                    Must be provided a valid CompanyId for beneficiary user
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Company Id that has already been registered in the system and
                  this user is being registered as a beneficiary user for that
                  company.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span> If
                  IsBusinessEntity = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  FirstName<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), <br />
                    RegularExpression(@"^[a-zA-Z. ]*$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  First name of the user.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  LastName<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    StringLength(50), RegularExpression(@"^[a-zA-Z. ]*$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Last name of the user.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  DateOfBirth<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"DateTime"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Date of birth of the user. For example: 24 September 1990 or
                  09/24/2021
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Address<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}> StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Address of the user.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AptOrSuite
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(5)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Apartment or suite of the user.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Country
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  User’s current country of residence. <br />
                  Shoud be in ISO 2 format.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  State
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  The State where the user resides.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If Country
                  = USA or CAN
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  City<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), <br />
                    RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  User’s current city of residence.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ZipCode
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    StringLength(5)"XXXXX" for USA <br />& StringLength(7) "XXX
                    XXX" for CAN
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Zip code of the area where the user resides.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If Country
                  = USA or CAN
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  PhoneNumber<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(11), <br />
                    RegularExpression(@"\(?\d{3}\)?-? *\d{3}-? *-?\d{4}")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Current phone number of the user.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Email<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    Should be in email format
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Email of the user i.e JohnDoe@exampleDomain.com
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  NumberOfDependents<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    RegularExpression(@"[0-9]{1}")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Int"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  No. of dependents (if any) of the user. Enter 0 if none.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MaritalStatus<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Current marital status of the user. Expected values: [S =
                  Single, W = Widowed, D = Divorced, M= Married]
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SSN
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(9) for USA <br />
                    StringLength(11) for Outside USA
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  SSN of the user.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>NOT Required: </span>If
                  TaxIdType = APT
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ValidGovtIDType<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Valid Govt. ID Type the user will be providing: D = Driver
                  License, <br />P = Passport,
                  <br /> L = Local ID
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IDNumber<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Valid ID number of the government-issued ID.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IssueDate<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    {"IssueDate < ExpirationDate"}
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"DateTime"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Issue date of the government-issued ID.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ExpirationDate<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    {"IssueDate < ExpirationDate"}
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"DateTime"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  The expiration date of the government-issued ID.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IssuingCountry<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  The Country which issued government ID.
                  <br /> Should be in ISO 2 format.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IssuingState<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  State which issued government ID.
                  <br /> Shoud be in ISO 2 format.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IsW8OrW9Forms<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(1)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Taxpayer identification form, either W8 or W9. Expected
                  values:
                  <br />
                  8 = W8,
                  <br />9 = W9
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TaxStatus<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Incase of [8 ={">"} "W8 BEN", "W8 IMY", <br />
                  "W8 EC1", "W8 EXP", "{"<blank>"}"] and in case <br />
                  of [9 ={">"} "Individual", "S-Corp", "C-Corp", <br />
                  "Exempt", "{"<blank>"}"].
                  <br /> This field is space sensitive.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IsActiveOrDayTrader
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  By default, this is set to TRUE.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  JointFirstName
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Joint First name of the account.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ApplicationAccountType = "JCP" | "JROS" | "JTE" | "JTIC"
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  JointLastName
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Joint Last name of the account.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ApplicationAccountType = "JCP" | "JROS" | "JTE" | "JTIC"
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  JointRelation
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Relationship between the users of the joint account.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ApplicationAccountType = "JCP" | "JROS" | "JTE" | "JTIC"
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  JointSSN
                  <br />
                  <span style={{ color: "#999999" }}> StringLength(11)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Joint SSN of the account.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ApplicationAccountType = "JCP" | "JROS" | "JTE" | "JTIC"
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  JointDateOfBirth<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    Required If ApplicationAccountType = <br />
                    "JCP" | "JROS" | "JTE" | "JTIC"
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"DateTime"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Joint date of birth of the account.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  JointCountryOfCitizenship
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    Required If ApplicationAccountType = <br />
                    "JCP" | "JROS" | "JTE" | "JTIC"
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Joint country of citizenship. Must be in ISO2 format.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  JointIsW8OrW9Forms
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(1)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Joint taxpayer identification form either W8 or W9. Expected
                  values: 8 = W8,
                  <br /> 9 = W9
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ApplicationAccountType = "JCP" | "JROS" | "JTE" | "JTIC"
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentStatus
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Current employment status of the user. Expected values: E =
                  Employed,
                  <br />
                  R = Retired,
                  <br />
                  S = Self-Employed,
                  <br />
                  St = Student
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span> If
                  IsBusinessEntity = False
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmployerOrBusinessName
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  The name of the employer where the user is currently employed
                  or The company name of the user in case of self-employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  EmploymentStatus != R <br />
                  AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  OccupationOrComapnyType
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Occupation of the user or the company type of the company in
                  case of self-employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span> If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentAddress
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  The official address of the employer or the company.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span> If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentAptOrSuite
                  <br />
                  <span style={{ color: "#999999" }}> StringLength(5)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Apartment or suite of the employer or the company.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentYearsOfExperience
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Total years of experience in the said occupation or business.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span> If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentCountry
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Country of employment or the country where the company or
                  business is registered in case of self-employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span> If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentState
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  State of employment or the state where the company or business
                  is registered in case of self-employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span> If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentCity
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  City of employment or the city where the company or business
                  is registered in case of self-employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span> If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentPhone
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(11), RegularExpression(@"\(?\d{3}\)?-? *\d{3}-?
                    *-?\d{4}")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Phone number of the employer or the company or business
                  registered phone number in case of self-employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span> If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentFax
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Fax of employer or the company or business registered fax
                  number in case of self-employed.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IsTrustedContactPersonAvailable
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  If there is another trusted contact person available. Default
                  value = False
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPName
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Name of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPPhoneNumber
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(11), RegularExpression(@"\(?\d{3}\)?-? *\d{3}-?
                    *-?\d{4}")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Phone number of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPEmail
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Email of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPAddress
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Address of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPCountry
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Country of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPState
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  State of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPCity
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  City of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPZip
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(10), RegularExpression(@"^[0-9a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Zip code of another trusted contact person
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPRelationToAccountHolder
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Relation of another trusted contact person with the user
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPDateOfBirth
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"DateTime"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Date of birth of another trusted contact person. For example,
                  24 September 1990.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IsMailingAddressDifferent
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  If there is a different mailing address. Default value = False
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MAAddress
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              Required: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Address value of mailing address
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Address value of mailing address.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MAAptOrSuite
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(5)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Apartment or suite of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MACity
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  City of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MAZipCode
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(10), RegularExpression(@"^[0-9a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Zip code of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MACountry
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Country of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MAState
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  State of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  FrontIdentification<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    1KB - 8MB, Allowed formats = <br />
                    ".jpeg", ".jpg", ".png"
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Base64 Encoded Front side image of the valid government-issued
                  ID
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  BackIdentification<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    1KB - 8MB, ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Base64 Encoded Back side image of the Identification proof
                  ;IF(IdentificationProofType=1):Allowed formats = ".jpeg",
                  ".jpg", ".png" ELSE IF(IdentificationProofType=2):Allowed
                  formats = ".pdf"
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  UserSignature
                  <br />
                  <span style={{ color: "#999999" }}>
                    1KB - 8MB, Allowed formats = <br />
                    ".jpeg", ".jpg", ".png"
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Base64 Encoded Image of the user signature
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  InvestmentRiskTolerance
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Value for investment risk tolerance i.e 1 = Conservative,
                  <br /> 2 = Moderately Conservative,
                  <br /> 3 = Moderate,
                  <br /> 4 = Moderately Aggressive,
                  <br /> 5 = Significant Risk.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsBusinessEntity = False
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AccountTypes<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    StringLength(2), RegularExpression("MC|CM|C|M")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  M = margin, C = cash,
                  <br /> MC= margin&cash,
                  <br /> CM= margin&cash.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IdentificationProofType
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Value for Identification Proof Type i.e <br />1 = Government
                  issued ID,
                  <br /> 2 = Utility bill & Passport.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  GroupCode
                  <br />
                  <span style={{ color: "#999999" }}>
                    ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  GroupCode of the firm for InteliClear. Expected Values:
                  retrieve from GET{" "}
                  {"<base URL>/API/v1/ApiOptions/Details?optionName=GroupCode "}
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TaxIdType<span style={{ color: "#ff4848" }}>*</span> <br />
                  <span style={{ color: "#999999" }}>
                    ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  ExpectedValues = EIN, ITN, SSN, TIN, APT
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ForeignIdType <br />
                  <span style={{ color: "#999999" }}>
                    ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  ExpectedValues = SSN, TIN, FTN, GIIN
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If Country
                  != USA
                </MDTypography>
              ),
            },
          ],
        },
        otherData: {
          // heading: "Update Request of Beneficiary User Information API",
          // desc: 'his API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, the user must send the "CompanyID" and the "UserIdentifierCode" data fields with the other data fields. This company ID and user ID refers to the company and the beneficiary user whose data needs to be updated.',
        },
        // respObjKey: "beneficiaryRouteUrl"
      },
      {
        mainGridId: "company-account-funding-api",
        routeUrlId: "company-account-api-route-url",
        dataFeildId: "company-account-api-data-fields",
        subHeading: "Company Account Funding API",
        endPointHeading: "Request Endpoint",
        endPointDesc: "<base URL>/API/v1/company/accountfunding",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the Company Account Funding API is as follows:",
        requestHeaderTable: requestHeaderTableData,
        dataFieldHeading: "Data Fields",
        dataFieldDesc:
          "The Company Account Funding API can be called by providing the data fields in the raw JSON body of the request. Each field must be encrypted and follow the validations for the request to be completed successfully.",
        updateRequestTitle: "Update Request of Company Account Funding API ",
        updateRequestDes:
          "This Company Account Funding API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, the user must send the “CompanyID” data field with the other data fields. This company ID refers to the company whose data needs to be updated. ",
        dataFieldTable: {
          columns: [
            {
              Header: "Field Name",
              accessor: "fieldName",
              align: "left",
              width: "15%",
            },
            { Header: "", accessor: "dataType", align: "center", width: "5%" },
            { Header: "Comments", accessor: "comments", align: "left" },
          ],
          rows: [
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  CompanyId<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Company id of the company/organization/LLC whose data is going
                  to be posted in API
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IncomeSource<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    ValidateExpectedValues(Multiple = true)
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"List<string>"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Income source type of the user from which he is funding his
                  account. Expected values: 1 = Income,
                  <br /> 2 = Pension or retirement,
                  <br /> 3 = Gift,
                  <br /> 4 = Sale of business or property,
                  <br /> 5 = Inheritance,
                  <br /> 6 = Social Security benefit,
                  <br /> 7 = Other
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  OtherIncomeSource<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Income source types other than the values described above.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IncomeSource = "7"
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AccountFundingBankName
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Name of bank where the user has the account
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ABAOrSWIFT<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}> StringLength(50)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  ABA or SWIFT code of the user’s bank
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AccountFundingBank
                  <br />
                  AccountNumber<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(50)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  User’s Account number
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AccountFundingAccountType
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(50)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  User’s bank Account type
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AccountFundingAccountTitle
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(50)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  User’s Account title
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ApproximateInitialDeposit
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(50)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  The initial amount that the account will be depositing. For
                  example, $30,000
                </MDTypography>
              ),
            },
          ],
        },
        otherData: {
          // heading: "Update Request of Company Account Funding API",
          // desc: 'This API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, the user must send the "CompanyID" data field with the other data fields. This company ID refers to the company whose data needs to be updated.',
        },
        // respObjKey: "fundingRouteUrl"
      },
      {
        mainGridId: "company-other-data-api",
        routeUrlId: "company-other-data-api-route-url",
        dataFeildId: "company-other-data-api-data-fields",
        subHeading: "Company Other Data API",
        endPointHeading: "Request Endpoint",
        endPointDesc: "<base URL>/API/v1/company/otherdata",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the Company Other Data API is as follows:",
        requestHeaderTable: requestHeaderTableData,
        dataFieldHeading: "Data Fields",
        dataFieldDesc:
          "The Company Other Data API can be called by providing the data fields in the form-data body of the request. Each field must be encrypted and follow the validations for the request to be completed successfully.",
        // updateRequestTitle: "Update Request of Company Other Data API ",
        // updateRequestDes: "This Company Other Data API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, the user must send the “CompanyID” data field with the other data fields. This company ID refers to the company whose data needs to be updated. ",
        dataFieldTable: {
          columns: [
            {
              Header: "Field Name",
              accessor: "fieldName",
              align: "left",
              width: "20%",
            },
            { Header: "", accessor: "dataType", align: "center", width: "5%" },
            { Header: "Comments", accessor: "comments", align: "left" },
          ],
          rows: [
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  CompanyId<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Company Id of the company/organization/LLC whose data is going
                  to be posted in API
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AnnualIncome<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the annual income. Expected values i.e <br />1 =
                  $25,000 and under,
                  <br /> 2 = $25,001 - $50,000,
                  <br /> 3 = $50,001 - $100,000,
                  <br /> 4 = $100,001 - $250000,
                  <br /> 5 = $250,001 ‐ $500,000,
                  <br /> 6 = over $500,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  NetWorthExcludingResidence
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the net worth excluding residence i.e <br />1 =
                  $25,000 and under,
                  <br /> 2 = $25,001 - $50,000,
                  <br /> 3 = $50,001 - $200,000,
                  <br /> 4 = $200,001 - $500,000,
                  <br /> 5 = $500,001 ‐ $1,000,000,
                  <br /> 6 = over $1,000,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  LiquidNetWorthWorth<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the liquid net worth. Expected values i.e <br />1 =
                  $25,000 and under,
                  <br /> 2 = $25,001 - $50,000,
                  <br /> 3 = $50,001 - $200,000,
                  <br /> 4 = $200,001 - $500,000,
                  <br /> 5 = $500,001 ‐ $1,000,000,
                  <br /> 6 = over $1,000,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TaxRate<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the tax rate. Expected values i.e <br />1 = 0 - 15,
                  <br /> 2 = 16 - 25,
                  <br /> 3 = 26 - 30,
                  <br /> 4 = 31 - 35,
                  <br /> 5 = over 35
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  InvestmentObjectives
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the investment objectives. Expected values i.e <br />{" "}
                  1 = Active or Day Trading,
                  <br /> 2 = Short-Term Trading
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AnnualExpenses<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the annual expenses. Expected values i.e <br /> 1 =
                  $50,000 and under, <br />2 = $50,001 - $100,000, 3 = $100,001
                  - $250,000, <br />4 = $250,001 ‐ $500,000, 5 = over $500,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SpecialExpenses<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the special expenses. Expected values i.e <br /> 1 =
                  $50,000 and under,
                  <br /> 2 = $50,001 - $100,000,
                  <br /> 3 = $100,001 - $250,000,
                  <br /> 4 = $250,001 ‐ $500,000,
                  <br /> 5 = over $500,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  LiquidityNeeds<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Values of the liquidity needs. Expected values i.e <br />1 =
                  Very Important,
                  <br /> 2 = Important, <br />3 = Somewhat important,
                  <br /> 4 = Does not matter
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TimeToAchieveFinancialGoal
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the time to achieve financial goal. Expected values
                  i.e <br />1 = Under 1 year,
                  <br /> 2 = 1 - 2,
                  <br /> 3 = 3 - 5,
                  <br /> 4 = 6 - 10,
                  <br /> 5 = 11 - 20,
                  <br /> 6 = Over 20.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AssetClasses<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"List<AssetClassValue>"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the time to achieve financial goal. Expected values
                  i.e <br />1 = Stocks,
                  <br /> 2 = Fixed Income, <br />3 = Options, <br />4 = Futures
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  HaveOtherBrokerageAccounts
                  <span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Does the account holder have other brokerage accounts?
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  NumberOfBrokerageAccounts
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Int"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  No. of other brokerage accounts
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  HaveOtherBrokerageAccounts = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  HaveOtherVelocityAccounts
                  <span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Does the account holder have the other Velocity accounts?
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  HaveOtherVelocityAccountsNumber
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Number of other velocity accounts
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  HaveOtherVelocityAccounts = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  HaveOtherVelocityAccountsName
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Name of another velocity accounts
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  HaveOtherVelocityAccounts = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  KnowAnyVelocityAccountHolder
                  <span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Does the account holder know any Velocity account holder?
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  KnowAnyVelocityAccountHolderNumber
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Velocity account holder's number whom the user knows
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  KnowAnyVelocityAccountHolder = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  KnowAnyVelocityAccountHolderName
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Velocity account holder's name whom the user knows
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  KnowAnyVelocityAccountHolder = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  KnowAnyVelocityAccountHolderRelationship
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Velocity account holder's relationship with the user
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  KnowAnyVelocityAccountHolder = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ShareholderInPubliclyTradedCompany
                  <span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Are either the user or an immediate family member an officer,
                  director, or at least 10% shareholder in a publicly traded
                  company?
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ShareholderInPubliclyTradedCompanyName
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Name of the publicly traded company
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ShareholderInPubliclyTradedCompany = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ShareholderInPubliclyTradedCompanyAddress
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Address of the publicly traded company
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ShareholderInPubliclyTradedCompany = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ShareholderInPubliclyTradedCompanyRelationship
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Relation with the entity that's in a publicly traded company
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ShareholderInPubliclyTradedCompany = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  RegisteredBrokerDealerSecuritiesExchangeOrFINRA
                  <span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Is either the user or an immediate family member employed by
                  FINRA, a registered broker-dealer, or a securities exchange?
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  RegisteredBrokerDealerSecuritiesExchangeOrFINRAName
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Name of the broker-dealer firm or securities exchange
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  RegisteredBrokerDealerSecuritiesExchangeOrFINRA = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  RegisteredBrokerDealerSecuritiesExchangeOrFINRAAddress
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Address of the broker-dealer firm or securities exchange
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  RegisteredBrokerDealerSecuritiesExchangeOrFINRA = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  RegisteredBrokerDealerSecuritiesExchangeOrFINRAPermissionToAccountOpeningFile
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Base64 Encoded Image of the permission document (by
                  broker-dealer firm/ security exchange)to open the account
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  RegisteredBrokerDealerSecuritiesExchangeOrFINRA = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SeniorOfficerAtFinancialInstitution
                  <span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Is the user a senior officer at a bank, savings and loan
                  institution, investment company, investment advisory firm, or
                  other financial institution?
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SeniorOfficerAtFinancialInstitutionName
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Name of the financial institution
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  SeniorOfficerAtFinancialInstitution = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SeniorOfficerAtFinancialInstitutionAddress
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Address of the financial institution
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  SeniorOfficerAtFinancialInstitution = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SeniorOfficerAtFinancialInstitutionPosition
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Position at the financial institution
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  SeniorOfficerAtFinancialInstitution = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  KnowAnyPublicOrPoliticalFigure
                  <span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Is the user a principals or authorized individuals a senior
                  political figure, a family member, or a relative of a senior
                  political figure?
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  KnowAnyPublicOrPoliticalFigureName
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Name of the public/political figure
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  KnowAnyPublicOrPoliticalFigure = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  KnowAnyPublicOrPoliticalFigurePosition
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Position of public/political figure
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  KnowAnyPublicOrPoliticalFigure = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  KnowAnyPublicOrPoliticalFigureRelationship
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Relationship with the public/political figure
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  KnowAnyPublicOrPoliticalFigure = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TaxWithholdingCertifications
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the tax withholding certifications. Expected values
                  i.e
                  <br />
                  <br />
                  "USP" = US person under penalty of perjury.
                  <br />
                  <br />
                  "CI" = I cannot certify that I am not subject to backup
                  withholding, meaning that I have been notified by the IRS that
                  I am currently subject to backup withholding because I have
                  failed to report all interest and dividends on my tax return.
                  <br />
                  <br />
                  "NRA" = I certify that I am not a U.S. resident alien or other
                  U.S. person for U.S. tax purposes and I am submitting the
                  applicable Form W-8 with this application to certify my
                  foreign status and if applicable, claim tax treaty benefits.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IsSubjectToBackupWitholding
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  The default is True.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  TaxWithholdingCertifications = USP
                  <br />
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SubjectToBackupWitholdingReason
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Reason for not subject to backup withholding i.e.
                  <br />
                  <br />
                  1 = I am exmpt from backup withholding.
                  <br />
                  <br />
                  2 = I have not been notified by the Internal Revenue Services
                  (IRS) that I am subject to backup withholding as a result of
                  failure to report all interest or dividends.
                  <br />
                  <br />
                  3 = The IRS has notified me that I am no longer subject to
                  backup withholding.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  SubjectToBackupWitholding = False
                </MDTypography>
              ),
            },
          ],
        },
        otherData: {
          // heading: "Update Request of Company Other Data API",
          // desc: 'This API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, the user must send the "CompanyID" data field with the other data fields. This company ID refers to the company whose data needs to be updated.',
          heading: "Asset Class",
          desc: "",
          updateRequestTitle: "Update Request of Company Other Data API",
          updateRequestDes:
            "This Company Other Data API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, the user must send the “CompanyID” data field with the other data fields. This company ID refers to the company whose data needs to be updated. ",
          tableData: {
            columns: [
              {
                Header: "Field Name",
                accessor: "fieldName",
                align: "left",
                width: "15%",
              },
              {
                Header: "",
                accessor: "dataType",
                align: "center",
                width: "5%",
              },
              { Header: "Comments", accessor: "comments", align: "left" },
            ],
            rows: [
              {
                fieldName: (
                  <MDTypography
                    component="p"
                    variant="button"
                    color="text"
                    fontWeight="regular"
                  >
                    AssetClass<span style={{ color: "#ff4848" }}>*</span>
                    <br />
                    <span style={{ color: "#999999" }}>
                      StringLength(1), ValidateExpectedValues
                    </span>
                  </MDTypography>
                ),
                dataType: (
                  <MDTypography
                    component="p"
                    variant="button"
                    color="text"
                    fontWeight="regular"
                  >
                    <MDBadge
                      color="success"
                      badgeContent={"String"}
                      variant="gradient"
                      size="sm"
                    ></MDBadge>
                  </MDTypography>
                ),
                comments: (
                  <MDTypography
                    component="p"
                    variant="caption"
                    color="text"
                    fontWeight="regular"
                    display="block"
                  >
                    Values of the asset class. Expected values i.e
                    <br />
                    1 = Stocks,
                    <br />
                    2 = Fixed Income,
                    <br />
                    3 = Options,
                    <br />4 = Futures
                  </MDTypography>
                ),
              },
              {
                fieldName: (
                  <MDTypography
                    component="p"
                    variant="button"
                    color="text"
                    fontWeight="regular"
                  >
                    YearsOfExperience<span style={{ color: "#ff4848" }}>*</span>
                    <br />
                    <span style={{ color: "#999999" }}>
                      StringLength(1), ValidateExpectedValues
                    </span>
                  </MDTypography>
                ),
                dataType: (
                  <MDTypography
                    component="p"
                    variant="button"
                    color="text"
                    fontWeight="regular"
                  >
                    <MDBadge
                      color="success"
                      badgeContent={"String"}
                      variant="gradient"
                      size="sm"
                    ></MDBadge>
                  </MDTypography>
                ),
                comments: (
                  <MDTypography
                    component="p"
                    variant="caption"
                    color="text"
                    fontWeight="regular"
                    display="block"
                  >
                    Value of the years of experience. Expected values i.e <br />
                    1 = 0,
                    <br />
                    2 = 1 - 5,
                    <br />3 = 5+
                  </MDTypography>
                ),
              },
              {
                fieldName: (
                  <MDTypography
                    component="p"
                    variant="button"
                    color="text"
                    fontWeight="regular"
                  >
                    Knowledge<span style={{ color: "#ff4848" }}>*</span>
                    <br />
                    <span style={{ color: "#999999" }}>
                      StringLength(1), ValidateExpectedValues
                    </span>
                  </MDTypography>
                ),
                dataType: (
                  <MDTypography
                    component="p"
                    variant="button"
                    color="text"
                    fontWeight="regular"
                  >
                    <MDBadge
                      color="success"
                      badgeContent={"String"}
                      variant="gradient"
                      size="sm"
                    ></MDBadge>
                  </MDTypography>
                ),
                comments: (
                  <MDTypography
                    component="p"
                    variant="caption"
                    color="text"
                    fontWeight="regular"
                    display="block"
                  >
                    Value of the knowledge. Expected values i.e <br />
                    1 = None,
                    <br />
                    2 = Limited,
                    <br />
                    3 = Good,
                    <br />4 = Extensive
                  </MDTypography>
                ),
              },
            ],
          },
        },
        // respObjKey: "fundingRouteUrl"
      },
      {
        mainGridId: "company-update-api",
        routeUrlId: "company-update-api-route-url",
        dataFeildId: "company-update-api-data-fields",
        subHeading: "Company Update API",
        endPointHeading: "Request Endpoint",
        endPointDesc: "<base URL>/API/v1/company/update",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the Company Update API is as follows:",
        requestHeaderTable: {
          columns: [
            { Header: "S/N", accessor: "num", align: "left", width: "5%" },
            { Header: "Key", accessor: "key", align: "left", width: "10%" },
            { Header: "Value", accessor: "value", align: "left" },
          ],
          rows: [
            {
              num: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  1
                </MDTypography>
              ),
              key: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Authorization
                </MDTypography>
              ),
              value: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  {"Bearer <token>"}
                </MDTypography>
              ),
            },
          ],
        },
        dataFieldHeading: "Data Fields",
        dataFieldDesc:
          "The Company Update API can be called by providing the data fields in the form-data body of the request after an account is accepted. Each field must be encrypted and follow the validations for the request to be completed successfully. In response, you will receive an OTP email using that OTP in VerifyOtp API Endpoint.",
        dataFieldTable: {
          columns: [
            {
              Header: "Field Name",
              accessor: "fieldName",
              align: "left",
              width: "15%",
            },
            { Header: "", accessor: "dataType", align: "center", width: "5%" },
            { Header: "Comments", accessor: "comments", align: "left" },
          ],
          rows: [
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  CompanyId<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Company ID of the company/organization/LLC whose data is going
                  to be posted in API.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  CompanyName
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"List<string>"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Name of the company / organization / LLC
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  OtherIncomeSource
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Address of the company
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AptOrSuite
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(5)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Apartment or suite where the company is located.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Country<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}> StringLength(50)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  The country where the company is located.
                  <br />
                  (Shoud be in ISO 2 format)
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  State
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  The State where the company is located.
                  <br />
                  (Shoud be in ISO 2 format)
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  City
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  The current city where the company is located.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ZipCode<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(5)"XXXXX" for USA & StringLength(7) "XXX XXX"
                    for CAN
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Zip code of the area where the company is located.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  PhoneNumber
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(11), RegularExpression(@"\(?\d{3}\)?-? *\d{3}-?
                    *-?\d{4}")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Current phone number of the company or authorized personnel
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IsMailingAddressDifferent
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  If there is different mailing address. Default value = False
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MACompanyAddress
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Address value of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsBusinessEntity = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MAAptOrSuite
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Apartment or suite of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MACity
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  City of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MAZipCode
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(10), RegularExpression(@"^[0-9a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Zip code of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MACountry
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Country of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MAState
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  State of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  LiquidNetWorth
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the liquid net worth. Expected values i.e
                  <br />
                  1 = $25,000 and under,
                  <br />
                  2 = $25,001 - $50,000,
                  <br />
                  3 = $50,001 - $200,000,
                  <br />
                  4 = $200,001 - $500,000,
                  <br />
                  5 = $500,001 ‐ $1,000,000,
                  <br />6 = over $1,000,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TaxRate
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the tax rate. Expected values i.e
                  <br />
                  1 = 0 - 5,
                  <br />
                  2 = 16 - 25,
                  <br />
                  3 = 26 - 30,
                  <br />
                  4 = 31 - 35,
                  <br />5 = over 35
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  InvestmentObjectives
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the investment objectives. Expected values i.e
                  <br />
                  1 = Active or Day Trading,
                  <br />2 = Short Term Trading
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AnnualExpenses
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the annual expenses. Expected values i.e
                  <br />
                  1 = $50,000 and under,
                  <br />
                  2 = $50,001 - $100,000,
                  <br />
                  3 = $100,001 - $250,000,
                  <br />
                  4 = $250,001 ‐ $500,000,
                  <br />5 = over $500,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SpecialExpenses
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the special expenses. Expected values i.e
                  <br />
                  1 = $50,000 and under,
                  <br />
                  2 = $50,001 - $100,000,
                  <br />
                  3 = $100,001 - $250,000,
                  <br />
                  4 = $250,001 ‐ $500,000,
                  <br />5 = over $500,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  LiquidityNeeds
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValue
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Values of the liquidity needs. Expected values i.e
                  <br />
                  1 = Very Important,
                  <br />
                  2 = Important,
                  <br />
                  3 = Somewhat important,
                  <br />4 = Does not matter
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TimeToAchieveFinancialGoal
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the time to achieve financial goal. Expected values
                  i.e
                  <br />
                  1 = Under 1 year,
                  <br />
                  2 = 1 - 2,
                  <br />
                  3 = 3 - 5,
                  <br />
                  4 = 6 - 10,
                  <br />
                  5 = 11 - 20,
                  <br />6 = Over 20
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AssetClasses
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"string"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Values of the asset class. Expected values i.e. <br />
                  1 = Stocks, <br />
                  2 = Fixed Income, <br />
                  3 = Options, <br />
                  4 = Futures
                  <br />
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  InvestmentRiskTolerance
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValue
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value for investment risk tolerance i.e
                  <br />
                  1 = Conservative,
                  <br />
                  2 = Moderately Conservative,
                  <br />
                  3 = Moderate,
                  <br />
                  4 = Moderately Aggressive,
                  <br />5 = Significant Risk
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Email
                  <br />
                  <span style={{ color: "#999999" }}>
                    Should be in email format
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Email of the user i.e JohnDoe@exampleDomain.com
                </MDTypography>
              ),
            },
          ],
        },
      },
      {
        mainGridId: "company-otp-api",
        routeUrlId: "company-otp-api-route-url",
        subHeading: "Company OTP API",
        endPointHeading: "Request Endpoint",
        endPointDesc:
          "<base URL>/API/v1/company/verifyotp?useridentifiercode=< useridentifiercode >&otp=<otp>",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the Company OTP API is as follows:",
        requestHeaderTable: {
          columns: [
            { Header: "S/N", accessor: "num", align: "left", width: "5%" },
            { Header: "Key", accessor: "key", align: "left", width: "10%" },
            { Header: "Value", accessor: "value", align: "left" },
          ],
          rows: [
            {
              num: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  1
                </MDTypography>
              ),
              key: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Authorization
                </MDTypography>
              ),
              value: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  {"Bearer <token>"}
                </MDTypography>
              ),
            },
          ],
        },
      },
    ],
  },

  // Signup Data
  Signup: {
    children: [
      {
        parentid: "individual-user-iu-joint-account-ja-signup-apis",
        mainHeading: "Individual User (IU)/Joint Account (JA) (Signup) APIs",
        mainGridId: "iu-ja-signup-initial-information-api",
        routeUrlId: "signup-initial-information-api-route-url",
        dataFeildId: "signup-initial-information-api-data-fields",
        subHeading: "IU/JA Signup Initial Information API",
        endPointHeading: "Request Endpoint",
        endPointDesc: "<base URL>/API/v1/signup/initial",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the Signup Initial Information API is as follows:",
        requestHeaderTable: {
          columns: [
            { Header: "S/N", accessor: "num", align: "left", width: "5%" },
            { Header: "Key", accessor: "key", align: "left", width: "10%" },
            { Header: "Value", accessor: "value", align: "left" },
          ],
          rows: [
            {
              num: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  1
                </MDTypography>
              ),
              key: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Authorization
                </MDTypography>
              ),
              value: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  {"Bearer <token>"}
                </MDTypography>
              ),
            },
          ],
        },
        dataFieldHeading: "Data Fields",
        dataFieldDesc:
          "The Signup Initial Information API can be called by providing the data fields in the form-data body of the request. Each field must be encrypted and follow the validations for the request to be completed successfully.",
        updateRequestTitle: "Update Request of Signup Initial Information API",
        updateRequestDes:
          "This Signup Initial Information API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, the user must send the “UserIdentifierCode” data field with the other data fields. This user ID refers to the user whose data needs to be updated. ",
        dataFieldTable: {
          columns: [
            {
              Header: "Field Name",
              accessor: "fieldName",
              align: "left",
              width: "20%",
            },
            { Header: "", accessor: "dataType", align: "center", width: "5%" },
            { Header: "Comments", accessor: "comments", align: "left" },
          ],
          rows: [
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  UserIdentifierCode
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  To update the data of an already created user, enter an
                  already created UserIdentifierCode. This is only possible if
                  the application is not yet completed.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IsBusinessEntity
                  <br />
                  <span style={{ color: "#999999" }}>
                    Must be TRUE for adding a beneficiary user
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Does the data entered belongs to an organization or LLC?
                  Default value = False. Must be set to True for the beneficiary
                  user.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ApplicationAccountType
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  The type of account that needs to be opened. Expected values:
                  <br />
                  "INDIV",
                  <br />
                  "JCP",
                  <br />
                  "JROS",
                  <br />
                  "JTE",
                  <br />
                  "JTIC",
                  <br />
                  "LLC"
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  CompanyId
                  <br />
                  <span style={{ color: "#999999" }}>
                    Must be provided a valid CompanyId for beneficiary user
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Company Id that has already been registered in the system and
                  this user is being registered as a beneficiary user for that
                  company.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsBusinessEntity = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  FirstName<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-zA-Z. ]*$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  First name of the user.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  LastName<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-zA-Z. ]*$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Last name of the user.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  DateOfBirth<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"DateTime"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Date of birth of the user. For example, 24 September 1990 or
                  09/24/2021
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Address<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Address of the user.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AptOrSuite
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(5)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Apartment or suite of the user.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Country<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Current country of residence of the user. Should be in ISO 2
                  format.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  State
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  The current State of the user (Should be in ISO 2 format)
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If Country
                  = USA or CAN
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  City<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  The current city of the user.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ZipCode
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(5)"XXXXX" for USA & StringLength(7) "XXX XXX"
                    for CAN
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Current zip code of the user.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If Country
                  = USA or CAN
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  PhoneNumber<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(11), RegularExpression(@"\(?\d{3}\)?-? *\d{3}-?
                    *-?\d{4}")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Current phone number of the user.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Email<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    Should be in email format
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Email of the user i.e JohnDoe@exampleDomain.com
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  NumberOfDependents<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    RegularExpression(@"[0-9]{1}")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Int"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  No. of dependents (if any) of the user. Enter 0 if none.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MaritalStatus<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Current marital status of the user. Expected values:
                  <br />
                  S = Single,
                  <br />
                  W = Widowed,
                  <br />
                  D = Divorced,
                  <br />
                  M= Married
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SSN
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(9) for USA StringLength(11) for Outside USA
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  SSN of the user.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>NOT Required: </span>If
                  TaxIdType = APT
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ValidGovtIDType<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Valid Govt. ID Type the user will be providing. i.e
                  <br />
                  D = Driver License,
                  <br />
                  P = Passport,
                  <br />L = Local ID
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IDNumber<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Valid ID number of the government-issued ID.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IssueDate<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    {"IssueDate < ExpirationDate"}
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"DateTime"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Issue date of the government-issued ID.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ExpirationDate<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    {"IssueDate < ExpirationDate"}
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"DateTime"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  The expiration date of the government-issued ID.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IssuingCountry<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  The country which issued government ID. Should be in ISO 2
                  format.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IssuingState<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  State which issued government ID. Should be in ISO 2 format.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IsW8OrW9Forms<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(1)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Taxpayer identification form, either W8 or W9. Expected
                  values:
                  <br />
                  8 = W8,
                  <br />9 = W9
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TaxStatus<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  {`Incase of [8 => "W8 BEN", "W8 IMY", "W8 EC1", "W8 EXP", "<blank>"] and in case of [9 => "Individual", "S-Corp", "C-Corp", "Exempt", "<blank>"]. This field is space sensitive.`}
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IsActiveOrDayTrader
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  By default, this is set to TRUE.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  JointFirstName
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Joint First Name of the account.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ApplicationAccountType = "JCP" | "JROS" | "JTE" | "JTIC"
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  JointLastName
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Joint Last Name of the account.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ApplicationAccountType = "JCP" | "JROS" | "JTE" | "JTIC"
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  JointRelation
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Relationship between the users of the joint account.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ApplicationAccountType = "JCP" | "JROS" | "JTE" | "JTIC"
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  JointSSN
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(11)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Joint SSN of the account.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ApplicationAccountType = "JCP" | "JROS" | "JTE" | "JTIC"
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  JointDateOfBirth
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"DateTime"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Joint date of birth of the account.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ApplicationAccountType = "JCP" | "JROS" | "JTE" | "JTIC"
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  JointCountryOfCitizenship
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Joint country of citizenship. Must be in ISO2 format.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ApplicationAccountType = "JCP" | "JROS" | "JTE" | "JTIC"
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  JointIsW8OrW9Forms
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(1)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Joint taxpayer identification form either W8 or W9. Expected
                  values:
                  <br />
                  8 = W8,
                  <br />
                  9 = W9
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ApplicationAccountType = "JCP" | "JROS" | "JTE" | "JTIC"
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentStatus
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Current employment status of the user. Expected values:
                  <br />
                  E = Employed,
                  <br />
                  R = Retired,
                  <br />
                  S = Self-Employed,
                  <br />
                  St = Student
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsBusinessEntity = False
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmployerOrBusinessName
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              fieldValidations: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                ></MDTypography>
              ),
              Required: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                >
                  Required If EmploymentStatus != R <br />
                  AND EmploymentStatus != St
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  The name of the employer where the user is currently employed
                  or The company name of the user in case of self-employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  OccupationOrComapnyType
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Occupation of the user or the type of the company in case of
                  self-employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentAddress
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  The official address of the employer or the company.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentAptOrSuite
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(5)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Apartment or suite of the employer or the company.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentYearsOfExperience
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Total years of experience in the said occupation or business.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentCountry
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Country of employment or the country where the company or
                  business is registered in case of self-employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentState
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  State of employment or the state where the company or business
                  is registered in case of self-employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentCity
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  City of employment or the city where the company or business
                  is registered in case of self-employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentPhone
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(11), RegularExpression(@"\(?\d{3}\)?-? *\d{3}-?
                    *-?\d{4}")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Phone number of the employer or the company or business
                  registered phone number in case of self-employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentFax
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Fax of employer or the the company or business registered fax
                  number in case of self employed.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IsTrustedContactPersonAvailable
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  If there is another trusted contact person available. Default
                  value = False
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPName
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Name of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPPhoneNumber
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(11), RegularExpression(@"\(?\d{3}\)?-? *\d{3}-?
                    *-?\d{4}")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Phone number of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPEmail
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Email of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPAddress
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Address of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPCountry
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Country of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPState
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  State of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPCity
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  City of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPZip
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    StringLength(10), RegularExpression(@"^[0-9a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Zip code of another trusted contact person
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPRelationToAccountHolder
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Relation of another trusted contact person with the user
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPDateOfBirth
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"DateTime"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Date of birth of another trusted contact person. For example,
                  24 September 1990.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IsMailingAddressDifferent
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  If there is a different mailing address. Default value = False
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MAAddress
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Address value of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MAAptOrSuite
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(5)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Apartment or suite of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MACity
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  City of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MAZipCode
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(10), RegularExpression(@"^[0-9a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Zip code of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MACountry
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Country of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MAState
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  State of mailing address
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsMailingAddressDifferent = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  FrontIdentification<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    1KB - 8MB, Allowed formats = ".jpeg", ".jpg", ".png"
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Base64 Encoded Front side image of the valid government-issued
                  ID
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  BackIdentification<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    1KB - 8MB, Allowed formats = ".jpeg", ".jpg", ".png"
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Base64 Encoded Back side image of the valid government-issued
                  ID
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  UserSignature
                  <br />
                  <span style={{ color: "#999999" }}>
                    1KB - 8MB, Allowed formats = ".jpeg", ".jpg", ".png"
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Base64 Encoded Image of the user signature
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  InvestmentRiskTolerance
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value for investment risk tolerance i.e
                  <br />
                  1 = Conservative,
                  <br />
                  2 = Moderately Conservative,
                  <br />
                  3 = Moderate,
                  <br />
                  4 = Moderately Aggressive,
                  <br />
                  5 = Significant Risk
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsBusinessEntity = False
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AccountTypes<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(2), RegularExpression("MC|CM|C|M")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  M = margin,
                  <br />
                  C = cash,
                  <br />
                  MC= margin&cash,
                  <br />
                  CM= margin&cash
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IdentificationProofType
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value for Identification Proof Type i.e
                  <br />
                  1 = Government-issued ID,
                  <br />2 = Utility bill & Passport
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  GroupCode
                  <br />
                  <span style={{ color: "#999999" }}>
                    ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  {
                    "GroupCode of the firm for Iclear. Expected Values: retrieve from  GET <base URL>/API/v1/ApiOptions/Details?optionName=GroupCode"
                  }
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TaxIdType<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  ExpectedValues = EIN, ITN, SSN, TIN, APT
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ForeignIdType
                  <br />
                  <span style={{ color: "#999999" }}>
                    ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  ExpectedValues = SSN, TIN, FTN, GIIN
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If Issuing
                  Country != USA
                </MDTypography>
              ),
            },
          ],
        },
        otherData: {
          // heading: "Update Request of Signup Initial Information API",
          // desc: 'This API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, the user must send the "UserIdentifierCode" data field with the other data fields. This user ID refers to the user whose data needs to be updated.',
        },
        // respObjKey: "signupInitialRouteUrl"
      },
      {
        mainGridId: "iu-ja-signup-account-funding-api",
        routeUrlId: "signup-account-funding-api-route-url",
        dataFeildId: "signup-account-funding-api-data-fields",
        subHeading: "IU/JA Signup Account Funding API",
        endPointHeading: "Request Endpoint",
        endPointDesc: "<base URL>/API/v1/signup/accountfunding",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the Signup Account Funding API is as follows:",
        requestHeaderTable: {
          columns: [
            { Header: "S/N", accessor: "num", align: "left", width: "5%" },
            { Header: "Key", accessor: "key", align: "left", width: "10%" },
            { Header: "Value", accessor: "value", align: "left" },
          ],
          rows: [
            {
              num: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  1
                </MDTypography>
              ),
              key: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Authorization
                </MDTypography>
              ),
              value: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  {"Bearer <token>"}
                </MDTypography>
              ),
            },
          ],
        },
        dataFieldHeading: "Data Fields",
        dataFieldDesc:
          "The Signup Account Funding API can be called by providing the data fields in the raw JSON body of the request. Each field must be encrypted and follow the validations for the request to be completed successfully. ",
        updateRequestTitle: "Update Request of Signup Account Funding API",
        updateRequestDes:
          "This Signup Account Funding API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, the user must send the “UserIdentifierCode” data field with the other data fields. This user ID refers to the user whose data needs to be updated. ",
        dataFieldTable: {
          columns: [
            {
              Header: "Field Name",
              accessor: "fieldName",
              align: "left",
              width: "20%",
            },
            { Header: "", accessor: "dataType", align: "center", width: "5%" },
            { Header: "Comments", accessor: "comments", align: "left" },
          ],
          rows: [
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  UserIdentifierCode<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  UserIdentifierCode of the company whose data is going to be
                  posted in API
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IncomeSource<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    ValidateExpectedValues(Multiple = true)
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"List<string>"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Income source type of the user from which he is funding his
                  account. Expected values:
                  <br />
                  1 = Income,
                  <br />
                  2 = Pension or retirement,
                  <br />
                  3 = Gift,
                  <br />
                  4 = Sale of business or property,
                  <br />
                  5 = Inheritance,
                  <br />
                  6 = Social Security benefit,
                  <br />7 = Other
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  OtherIncomeSource
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Income source types other than the values described above.{" "}
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IncomeSource = "7"
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AccountFundingBankName
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Name of bank where the user has the account
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ABAOrSWIFT
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(50)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  ABA or SWIFT code of the bank where the user has the account
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AccountFundingBankAccountNumber
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(50)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  User’s Account number
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AccountFundingAccountType
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(50)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  User’s Account type
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AccountFundingAccountTitle
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(50)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  User’s Account title
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ApproximateInitialDeposit
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(50)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  The initial amount that the account will be depositing. For
                  example, $30,000
                </MDTypography>
              ),
            },
          ],
        },
        otherData: {
          // heading: "Update Request of Signup Account Funding API",
          // desc: 'This API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, the user must send the "UserIdentifierCode" data field with the other data fields. This user ID refers to the user whose data needs to be updated.',
        },
        // respObjKey: "signupAccountRouteUrl"
      },
      {
        mainGridId: "iu-ja-signup-other-data-api",
        routeUrlId: "signup-other-data-api-route-url",
        dataFeildId: "signup-other-data-api-data-fields",
        subHeading: "IU/JA Signup Other Data API",
        endPointHeading: "Request Endpoint",
        endPointDesc: "<base URL>/API/v1/signup/otherdata",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the Signup Other Data API is as follows:",
        requestHeaderTable: {
          columns: [
            { Header: "S/N", accessor: "num", align: "left", width: "5%" },
            { Header: "Key", accessor: "key", align: "left", width: "10%" },
            { Header: "Value", accessor: "value", align: "left" },
          ],
          rows: [
            {
              num: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  1
                </MDTypography>
              ),
              key: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Authorization
                </MDTypography>
              ),
              value: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  {"Bearer <token>"}
                </MDTypography>
              ),
            },
          ],
        },
        dataFieldHeading: "Data Fields",
        dataFieldDesc:
          "The Signup Other Data API can be called by providing the data fields in the form-data body of the request. Each field must be encrypted and must follow the validations for the request to be completed successfully.",
        dataFieldTable: {
          columns: [
            {
              Header: "Field Name",
              accessor: "fieldName",
              align: "left",
              width: "15%",
            },
            { Header: "", accessor: "dataType", align: "center", width: "5%" },
            { Header: "Comments", accessor: "comments", align: "left" },
          ],
          rows: [
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  UserIdentifierCode<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  UserIdentifierCode of the user whose data is going to be
                  posted in API
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AnnualIncome<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the annual income. Expected values i.e
                  <br />
                  1 = $25,000 and under,
                  <br />
                  2 = $25,001 - $50,000,
                  <br />
                  3 = $50,001 - $100,000,
                  <br />
                  4 = $100,001 - $250000,
                  <br />
                  5 = $250,001 ‐ $500,000,
                  <br />6 = over $500,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  NetWorthExcludingResidence
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the net worth excluding residence i.e
                  <br />
                  1 = $25,000 and under,
                  <br />
                  2 = $25,001 - $50,000,
                  <br />
                  3 = $50,001 - $200,000,
                  <br />
                  4 = $200,001 - $500,000,
                  <br />
                  5 = $500,001 ‐ $1,000,000,
                  <br />6 = over $1,000,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  LiquidNetWorth<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the liquid net worth. Expected values i.e
                  <br />
                  1 = $25,000 and under,
                  <br />
                  2 = $25,001 - $50,000,
                  <br />
                  3 = $50,001 - $200,000,
                  <br />
                  4 = $200,001 - $500,000,
                  <br />
                  5 = $500,001 ‐ $1,000,000,
                  <br />6 = over $1,000,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TaxRate<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the tax rate. Expected values i.e
                  <br />
                  1 = 0 - 15,
                  <br />
                  2 = 16 - 25,
                  <br />
                  3 = 26 - 30,
                  <br />
                  4 = 31 - 35,
                  <br />5 = over 35
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  InvestmentObjectives
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the investment objectives. Expected values i.e
                  <br />
                  1 = Active or Day Trading,
                  <br />2 = Short-Term Trading
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AnnualExpenses<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the annual expenses. Expected values i.e
                  <br />
                  1 = $50,000 and under,
                  <br />
                  2 = $50,001 - $100,000,
                  <br />
                  3 = $100,001 - $250,000,
                  <br />
                  4 = $250,001 ‐ $500,000,
                  <br />5 = over $500,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SpecialExpenses<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the special expenses. Expected values i.e
                  <br />
                  1 = $50,000 and under,
                  <br />
                  2 = $50,001 - $100,000,
                  <br />
                  3 = $100,001 - $250,000,
                  <br />
                  4 = $250,001 ‐ $500,000,
                  <br />5 = over $500,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  LiquidityNeeds<span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Values of the liquidity needs. Expected values i.e
                  <br />
                  1 = Very Important,
                  <br />
                  2 = Important,
                  <br />
                  3 = Somewhat important,
                  <br />4 = Does not matter
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TimeToAchieveFinancialGoal
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the time to achieve a financial goal. Expected values
                  i.e
                  <br />
                  1 = Under 1 year,
                  <br />
                  2 = 1 - 2,
                  <br />
                  3 = 3 - 5,
                  <br />
                  4 = 6 - 10,
                  <br />
                  5 = 11 - 20,
                  <br />6 = Over 20
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AssetClasses<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"List<AssetClassValue>"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Values of the asset class. Expected values i.e.
                  <br />
                  1 = Stocks,
                  <br />
                  2 = Fixed Income,
                  <br />
                  3 = Options,
                  <br />4 = Futures
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  HaveOtherBrokerageAccounts
                  <span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Does the account holder have other brokerage accounts?
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  NumberOfBrokerageAccounts
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Int"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  No. of other brokerage accounts
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  HaveOtherBrokerageAccounts = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  HaveOtherVelocityAccounts
                  <span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Does the account holder have the other Velocity accounts?
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  HaveOtherVelocityAccountsNumber
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Number of other Velocity accounts
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  HaveOtherVelocityAccounts = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  HaveOtherVelocityAccountsName
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Name of other Velocity accounts
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  HaveOtherVelocityAccounts = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  KnowAnyVelocityAccountHolder
                  <span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Does the account holder know any Velocity account holder?
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  KnowAnyVelocityAccountHolderNumber
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Velocity account holder's number whom the user knows
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  KnowAnyVelocityAccountHolder = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  KnowAnyVelocityAccountHolderName
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Velocity account holder's name whom the user knows
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  KnowAnyVelocityAccountHolder = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  KnowAnyVelocityAccountHolderRelationship
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Velocity account holder's relationship with the user
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  KnowAnyVelocityAccountHolder = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ShareholderInPubliclyTradedCompany
                  <span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Are either the user or an immediate family member an officer,
                  director, or at least 10% shareholder in a publicly traded
                  company?
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ShareholderInPubliclyTradedCompanyName
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Name of the publicly traded company
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ShareholderInPubliclyTradedCompany = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ShareholderInPubliclyTradedCompanyAddress
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Address of the publicly traded company
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ShareholderInPubliclyTradedCompany = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ShareholderInPubliclyTradedCompanyRelationship
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Relation with the entity that's in a publicly traded company
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  ShareholderInPubliclyTradedCompany = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  RegisteredBrokerDealerSecuritiesExchangeOrFINRA
                  <span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Is either the user or an immediate family member employed by
                  FINRA, a registered broker-dealer, or a securities exchange?
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  RegisteredBrokerDealerSecuritiesExchangeOrFINRAName
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Name of the broker-dealer firm or securities exchange
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  RegisteredBrokerDealerSecuritiesExchangeOrFINRA = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  RegisteredBrokerDealerSecuritiesExchangeOrFINRAAddress
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Address of the broker-dealer firm or securities exchange
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  RegisteredBrokerDealerSecuritiesExchangeOrFINRA = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  RegisteredBrokerDealerSecuritiesExchangeOrFINRAPermissionToAccountOpeningFile
                  <br />
                  <span style={{ color: "#999999" }}>
                    1KB - 8MB, Allowed formats = ".jpeg", ".jpg", ".png"
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Base64 Encoded Image of the permission document (by
                  broker-dealer firm/ security exchange) to open the account
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  RegisteredBrokerDealerSecuritiesExchangeOrFINRA = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SeniorOfficerAtFinancialInstitution
                  <span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Is the user a senior officer at a bank, savings and loan
                  institution, investment company, investment advisory firm, or
                  other financial institution?
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SeniorOfficerAtFinancialInstitutionName
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Name of the financial institution
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  SeniorOfficerAtFinancialInstitution = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SeniorOfficerAtFinancialInstitutionAddress
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Address of the financial institution
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  SeniorOfficerAtFinancialInstitution = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SeniorOfficerAtFinancialInstitutionPosition
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Position at the financial institution
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  SeniorOfficerAtFinancialInstitution = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  KnowAnyPublicOrPoliticalFigure
                  <span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Is the user any principals or authorized individuals a senior
                  political figure, a family member, or a relative of a senior
                  political figure?
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  KnowAnyPublicOrPoliticalFigureName
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Name of the public/political figure
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  KnowAnyPublicOrPoliticalFigure = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  KnowAnyPublicOrPoliticalFigurePosition
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Position of public/political figure
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  KnowAnyPublicOrPoliticalFigure = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  KnowAnyPublicOrPoliticalFigureRelationship
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Relationship with the public/political figure
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  KnowAnyPublicOrPoliticalFigure = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TaxWithholdingCertifications
                  <span style={{ color: "#ff4848" }}>*</span>
                  <br />
                  <span style={{ color: "#999999" }}>
                    ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the tax withholding certifications. Expected values
                  i.e
                  <br />
                  <br />
                  "USP" = US person under penalty of perjury.
                  <br />
                  <br />
                  "CI" = I cannot certify that I am not subject to backup
                  withholding, meaning that I have been notified by the IRS that
                  I am currently subject to backup withholding because I have
                  failed to report all interest and dividends on my tax return.
                  <br />
                  <br />
                  "NRA" = I certify that I am not a U.S. resident alien or other
                  U.S. person for U.S. tax purposes and I am submitting the
                  applicable Form W-8 with this application to certify my
                  foreign status and if applicable, claim tax treaty benefits.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IsSubjectToBackupWitholding
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  The default is True.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  TaxWithholdingCertifications = USP
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SubjectToBackupWitholdingReason
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Reason for not subject to backup withholding i.e.
                  <br />
                  <br />
                  1 = I am exempt from backup withholding.
                  <br />
                  <br />
                  2 = I have not been notified by the Internal Revenue Services
                  (IRS) that I am subject to backup withholding as a result of
                  failure to report all interest or dividends.
                  <br />
                  <br />
                  3 = The IRS has notified me that I am no longer subject to
                  backup withholding.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  SubjectToBackupWitholding = False
                </MDTypography>
              ),
            },
          ],
        },
        // otherData: {
        //     heading: "Asset Class",
        //     desc: '',
        //     // updateRequestTitle: "Update Request of Company Other Data API ",
        //     // updateRequestDes: "This Company Other Data API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, the user must send the “CompanyID” data field with the other data fields. This company ID refers to the company whose data needs to be updated. ",
        //     tableData: {
        //         columns: [
        //             { Header: "Field Name", accessor: "fieldName", align: "left", width: "15%" },
        //             { Header: "", accessor: "dataType", align: "center", width: "5%" },
        //             { Header: "Comments", accessor: "comments", align: "left" },
        //         ],
        //         rows: [
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         UserIdentifierCode<span style={{ color: "#ff4848" }}>*</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         UserIdentifierCode of the user whose data is going to be posted in API
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         AnnualIncome<span style={{ color: "#ff4848" }}>*</span>
        //                         <br />
        //                         <span style={{ color: "#999999" }}>StringLength(1), ValidateExpectedValues</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Value of the annual income. Expected values i.e<br />
        //                         1 = $25,000 and under,<br />
        //                         2 = $25,001 - $50,000,<br />
        //                         3 = $50,001 - $100,000,<br />
        //                         4 = $100,001 - $250000,<br />
        //                         5 = $250,001 ‐ $500,000,<br />
        //                         6 = over $500,000
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         NetWorthExcludingResidence<span style={{ color: "#ff4848" }}>*</span>
        //                         <br />
        //                         <span style={{ color: "#999999" }}>StringLength(1), ValidateExpectedValues</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Value of the net worth excluding residence i.e<br />
        //                         1 = $25,000 and under,<br />
        //                         2 = $25,001 - $50,000,<br />
        //                         3 = $50,001 - $200,000,<br />
        //                         4 = $200,001 - $500,000,<br />
        //                         5 = $500,001 ‐ $1,000,000,<br />
        //                         6 = over $1,000,000
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         LiquidNetWorth<span style={{ color: "#ff4848" }}>*</span>
        //                         <br />
        //                         <span style={{ color: "#999999" }}>StringLength(1), ValidateExpectedValues</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Value of the liquid net worth. Expected values i.e<br />
        //                         1 = $25,000 and under,<br />
        //                         2 = $25,001 - $50,000,<br />
        //                         3 = $50,001 - $200,000,<br />
        //                         4 = $200,001 - $500,000,<br />
        //                         5 = $500,001 ‐ $1,000,000,<br />
        //                         6 = over $1,000,000
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         TaxRate<span style={{ color: "#ff4848" }}>*</span>
        //                         <br />
        //                         <span style={{ color: "#999999" }}>StringLength(1), ValidateExpectedValues</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Value of the tax rate. Expected values i.e<br />
        //                         1 = 0 - 15,<br />
        //                         2 = 16 - 25,<br />
        //                         3 = 26 - 30,<br />
        //                         4 = 31 - 35,<br />
        //                         5 = over 35
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         InvestmentObjectives<span style={{ color: "#ff4848" }}>*</span>
        //                         <br />
        //                         <span style={{ color: "#999999" }}>StringLength(1), ValidateExpectedValues</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Value of the investment objectives. Expected values i.e<br />
        //                         1 = Active or Day Trading,<br />
        //                         2 = Short-Term Trading
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         AnnualExpenses<span style={{ color: "#ff4848" }}>*</span>
        //                         <br />
        //                         <span style={{ color: "#999999" }}> StringLength(1), ValidateExpectedValues</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Value of the annual expenses. Expected values i.e<br />
        //                         1 = $50,000 and under,<br />
        //                         2 = $50,001 - $100,000,<br />
        //                         3 = $100,001 - $250,000,<br />
        //                         4 = $250,001 ‐ $500,000,<br />
        //                         5 = over $500,000
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         SpecialExpenses<span style={{ color: "#ff4848" }}>*</span>
        //                         <br />
        //                         <span style={{ color: "#999999" }}>StringLength(1), ValidateExpectedValues</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Value of the special expenses. Expected values i.e<br />
        //                         1 = $50,000 and under,<br />
        //                         2 = $50,001 - $100,000,<br />
        //                         3 = $100,001 - $250,000,<br />
        //                         4 = $250,001 ‐ $500,000,<br />
        //                         5 = over $500,000
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         LiquidityNeeds<span style={{ color: "#ff4848" }}>*</span>
        //                         <br />
        //                         <span style={{ color: "#999999" }}>StringLength(1), ValidateExpectedValues</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Values of the liquidity needs. Expected values i.e<br />
        //                         1 = Very Important,<br />
        //                         2 = Important,<br />
        //                         3 = Somewhat important,<br />
        //                         4 = Does not matter
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         TimeToAchieveFinancialGoal<span style={{ color: "#ff4848" }}>*</span>
        //                         <br />
        //                         <span style={{ color: "#999999" }}>StringLength(1), ValidateExpectedValues</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Value of the time to achieve a financial goal. Expected values i.e<br />
        //                         1 = Under 1 year,<br />
        //                         2 = 1 - 2,<br />
        //                         3 = 3 - 5,<br />
        //                         4 = 6 - 10,<br />
        //                         5 = 11 - 20,<br />
        //                         6 = Over 20
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         AssetClasses<span style={{ color: "#ff4848" }}>*</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"List<AssetClassValue>"} variant="gradient" size="sm"></MDBadge>

        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         AssetClassValue's description is given below
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         HaveOtherBrokerageAccounts<span style={{ color: "#ff4848" }}>*</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"Bool"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Does the account holder have other brokerage accounts?
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         NumberOfBrokerageAccounts
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"Int"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         No. of other brokerage accounts<br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If HaveOtherBrokerageAccounts = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         HaveOtherVelocityAccounts<span style={{ color: "#ff4848" }}>*</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"Bool"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Does the account holder have the other Velocity accounts?
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         HaveOtherVelocityAccountsNumber
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Number of other Velocity accounts
        //                         <br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If HaveOtherVelocityAccounts = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         HaveOtherVelocityAccountsName
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Name of other Velocity accounts
        //                         <br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If HaveOtherVelocityAccounts = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         KnowAnyVelocityAccountHolder<span style={{ color: "#ff4848" }}>*</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"Bool"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Does the account holder know any Velocity account holder?
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         KnowAnyVelocityAccountHolderNumber
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Velocity account holder's number whom the user knows<br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If KnowAnyVelocityAccountHolder = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         KnowAnyVelocityAccountHolderName
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Velocity account holder's name whom the user knows<br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If KnowAnyVelocityAccountHolder = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         KnowAnyVelocityAccountHolderRelationship
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Velocity account holder's relationship with the user<br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If KnowAnyVelocityAccountHolder = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         ShareholderInPubliclyTradedCompany
        //                         <span style={{ color: "#ff4848" }}>*</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"Bool"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Are either the user or an immediate family member an officer, director, or at least 10% shareholder in a publicly traded company?
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         ShareholderInPubliclyTradedCompanyName
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Name of the publicly traded company<br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If ShareholderInPubliclyTradedCompany = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         ShareholderInPubliclyTradedCompanyAddress
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Address of the publicly traded company<br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If ShareholderInPubliclyTradedCompany = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         ShareholderInPubliclyTradedCompanyRelationship
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Relation with the entity that's in a publicly traded company<br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If ShareholderInPubliclyTradedCompany = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         RegisteredBrokerDealerSecuritiesExchangeOrFINRA<span style={{ color: "#ff4848" }}>*</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"Bool"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Is either the user or an immediate family member employed by FINRA, a registered broker-dealer, or a securities exchange?
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         RegisteredBrokerDealerSecuritiesExchangeOrFINRAName
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"Bool"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Name of the broker-dealer firm or securities exchange
        //                         <br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If RegisteredBrokerDealerSecuritiesExchangeOrFINRA = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         RegisteredBrokerDealerSecuritiesExchangeOrFINRAAddress
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Address of the broker-dealer firm or securities exchange
        //                         <br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If RegisteredBrokerDealerSecuritiesExchangeOrFINRA = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         RegisteredBrokerDealerSecuritiesExchangeOrFINRAPermissionToAccountOpeningFile<br />
        //                         <span style={{ color: "#999999" }}>1KB - 8MB, Allowed formats = ".jpeg", ".jpg", ".png"</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Base64 Encoded Image of the permission document (by broker-dealer firm/ security exchange) to open the account<br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If RegisteredBrokerDealerSecuritiesExchangeOrFINRA = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         RegisteredBrokerDealerSecuritiesExchangeOrFINRAPermissionToAccountOpeningFile
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Base64 Encoded Image of the permission document (by broker dealer firm/ security exchange)to open the account<br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If RegisteredBrokerDealerSecuritiesExchangeOrFINRA = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         SeniorOfficerAtFinancialInstitution<span style={{ color: "#ff4848" }}>*</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"Bool"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Is the user a senior officer at a bank, savings and loan institution, investment company, investment advisory firm, or other financial institution?
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         SeniorOfficerAtFinancialInstitutionName
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Name of the financial institution<br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If SeniorOfficerAtFinancialInstitution = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         SeniorOfficerAtFinancialInstitutionAddress
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Address of the financial institution<br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If SeniorOfficerAtFinancialInstitution = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         SeniorOfficerAtFinancialInstitutionPosition
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Position at the financial institution<br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If SeniorOfficerAtFinancialInstitution = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         KnowAnyPublicOrPoliticalFigure<span style={{ color: "#ff4848" }}>*</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"Bool"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Is the user any principals or authorized individuals a senior political figure, a family member, or a relative of a senior political figure?
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         KnowAnyPublicOrPoliticalFigureName
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Name of the public/political figure
        //                         <br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If KnowAnyPublicOrPoliticalFigure = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         KnowAnyPublicOrPoliticalFigurePosition
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Position of public/political figure
        //                         <br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If KnowAnyPublicOrPoliticalFigure = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         KnowAnyPublicOrPoliticalFigureRelationship
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Relationship with the public/political figure
        //                         <br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If KnowAnyPublicOrPoliticalFigure = True
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         TaxWithholdingCertifications<span style={{ color: "#ff4848" }}>*</span>
        //                         <br />
        //                         <span style={{ color: "#999999" }}>ValidateExpectedValues</span>
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Value of the tax withholding certifications. Expected values i.e<br /><br />
        //                         "USP" = US person under penalty of perjury.<br /><br />
        //                         "CI" = I cannot certify that I am not subject to backup withholding, meaning that I have been notified by the IRS that I am currently subject to backup withholding because I have failed to report all interest and dividends on my tax return.<br /><br />
        //                         "NRA" = I certify that I am not a U.S. resident alien or other U.S. person for U.S. tax purposes and I am submitting the applicable Form W-8 with this application to certify my foreign status and if applicable, claim tax treaty benefits.
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         IsSubjectToBackupWitholding
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"Bool"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         The default is True.<br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If TaxWithholdingCertifications = USP
        //                     </MDTypography>
        //                 ),
        //             },
        //             {
        //                 fieldName: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         SubjectToBackupWitholdingReason
        //                     </MDTypography>),
        //                 dataType: (
        //                     <MDTypography component="p" variant="button" color="text" fontWeight="regular">
        //                         <MDBadge color="success" badgeContent={"String"} variant="gradient" size="sm"></MDBadge>
        //                     </MDTypography>
        //                 ),
        //                 comments: (
        //                     <MDTypography component="p" variant="caption" color="text" fontWeight="regular" display="block">
        //                         Reason for not subject to backup withholding i.e.<br /><br />
        //                         1 = I am exempt from backup withholding.<br /><br />
        //                         2 = I have not been notified by the Internal Revenue Services (IRS) that I am subject to backup withholding as a result of failure to report all interest or dividends.<br /><br />
        //                         3 = The IRS has notified me that I am no longer subject to backup withholding.<br /><br />
        //                         <span style={{ color: "#ff4848" }}>Required: </span>If SubjectToBackupWitholding = False
        //                     </MDTypography>
        //                 ),
        //             },

        //         ],
        //     }
        // },

        otherData: {
          // heading: "Update Request of Company Other Data API",
          // desc: 'This API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, the user must send the "CompanyID" data field with the other data fields. This company ID refers to the company whose data needs to be updated.',
          heading: "Asset Class",
          desc: "",
          updateRequestTitle: "Update Request of Signup Other Data API",
          updateRequestDes:
            "This Signup Other Data API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, the user must send the “UserIdentifierCode” data field with the other data fields. This user ID refers to the user whose data needs to be updated.",
          tableData: {
            columns: [
              {
                Header: "Field Name",
                accessor: "fieldName",
                align: "left",
                width: "15%",
              },
              {
                Header: "",
                accessor: "dataType",
                align: "center",
                width: "5%",
              },
              { Header: "Comments", accessor: "comments", align: "left" },
            ],
            rows: [
              {
                fieldName: (
                  <MDTypography
                    component="p"
                    variant="button"
                    color="text"
                    fontWeight="regular"
                  >
                    AssetClass<span style={{ color: "#ff4848" }}>*</span>
                    <br />
                    <span style={{ color: "#999999" }}>
                      StringLength(1), ValidateExpectedValues
                    </span>
                  </MDTypography>
                ),
                dataType: (
                  <MDTypography
                    component="p"
                    variant="button"
                    color="text"
                    fontWeight="regular"
                  >
                    <MDBadge
                      color="success"
                      badgeContent={"String"}
                      variant="gradient"
                      size="sm"
                    ></MDBadge>
                  </MDTypography>
                ),
                comments: (
                  <MDTypography
                    component="p"
                    variant="caption"
                    color="text"
                    fontWeight="regular"
                    display="block"
                  >
                    Values of the asset class. Expected values i.e
                    <br />
                    1 = Stocks,
                    <br />
                    2 = Fixed Income,
                    <br />
                    3 = Options,
                    <br />4 = Futures
                  </MDTypography>
                ),
              },
              {
                fieldName: (
                  <MDTypography
                    component="p"
                    variant="button"
                    color="text"
                    fontWeight="regular"
                  >
                    YearsOfExperience<span style={{ color: "#ff4848" }}>*</span>
                    <br />
                    <span style={{ color: "#999999" }}>
                      StringLength(1), ValidateExpectedValues
                    </span>
                  </MDTypography>
                ),
                dataType: (
                  <MDTypography
                    component="p"
                    variant="button"
                    color="text"
                    fontWeight="regular"
                  >
                    <MDBadge
                      color="success"
                      badgeContent={"String"}
                      variant="gradient"
                      size="sm"
                    ></MDBadge>
                  </MDTypography>
                ),
                comments: (
                  <MDTypography
                    component="p"
                    variant="caption"
                    color="text"
                    fontWeight="regular"
                    display="block"
                  >
                    Value of the years of experience. Expected values i.e <br />
                    1 = 0,
                    <br />
                    2 = 1 - 5,
                    <br />3 = 5+
                  </MDTypography>
                ),
              },
              {
                fieldName: (
                  <MDTypography
                    component="p"
                    variant="button"
                    color="text"
                    fontWeight="regular"
                  >
                    Knowledge<span style={{ color: "#ff4848" }}>*</span>
                    <br />
                    <span style={{ color: "#999999" }}>
                      StringLength(1), ValidateExpectedValues
                    </span>
                  </MDTypography>
                ),
                dataType: (
                  <MDTypography
                    component="p"
                    variant="button"
                    color="text"
                    fontWeight="regular"
                  >
                    <MDBadge
                      color="success"
                      badgeContent={"String"}
                      variant="gradient"
                      size="sm"
                    ></MDBadge>
                  </MDTypography>
                ),
                comments: (
                  <MDTypography
                    component="p"
                    variant="caption"
                    color="text"
                    fontWeight="regular"
                    display="block"
                  >
                    Value of the knowledge. Expected values i.e <br />
                    1 = None,
                    <br />
                    2 = Limited,
                    <br />
                    3 = Good,
                    <br />4 = Extensive
                  </MDTypography>
                ),
              },
            ],
          },
        },

        // respObjKey: "signupAccountRouteUrl"
      },
      {
        mainGridId: "iu-ja-signup-update-api",
        routeUrlId: "signup-update-data-api-route-url",
        dataFeildId: "signup-update-data-api-data-fields",
        subHeading: "IU/JA Signup Update API",
        endPointHeading: "Request Endpoint",
        endPointDesc: "<base URL>/API/v1/signup/update",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the Signup Update API is as follows:",
        requestHeaderTable: {
          columns: [
            { Header: "S/N", accessor: "num", align: "left", width: "5%" },
            { Header: "Key", accessor: "key", align: "left", width: "10%" },
            { Header: "Value", accessor: "value", align: "left" },
          ],
          rows: [
            {
              num: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  1
                </MDTypography>
              ),
              key: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Authorization
                </MDTypography>
              ),
              value: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  {"Bearer <token>"}
                </MDTypography>
              ),
            },
          ],
        },
        dataFieldHeading: "Data Fields",
        dataFieldDesc:
          "The Signup Update API can be called by providing the data fields in the form-data body of the request after an account is accepted. Each field must be encrypted and must follow the validations for the request to be completed successfully. In response, you will receive an OTP email using that OTP in VerifyOTP API endpoint.",
        dataFieldTable: {
          columns: [
            {
              Header: "Field Name",
              accessor: "fieldName",
              align: "left",
              width: "20%",
            },
            { Header: "", accessor: "dataType", align: "center", width: "5%" },
            { Header: "Comments", accessor: "comments", align: "left" },
          ],
          rows: [
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  UserIdentifierCode<span style={{ color: "#ff4848" }}>*</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  UserIdentifierCode of the user whose data is going to be
                  posted in API.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Address
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  User’s current residential address.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AptOrSuite
                  <br />
                  <span style={{ color: "#999999" }}> StringLength(5)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Apartment or suite of the user.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Country
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  User’s current country of residence.
                  <br />
                  Shoud be in ISO 2 format.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  State
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  User’s current State of residence.
                  <br />
                  Shoud be in ISO 2 format.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  City
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  User’s current city of residence.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  ZipCode
                  <br />
                  <span style={{ color: "#999999" }}>
                    {" "}
                    StringLength(5)"XXXXX" for USA & StringLength(7) "XXX XXX"
                    for CAN
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Current zip code of the of the user.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  PhoneNumber
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(11), RegularExpression(@"\(?\d{3}\)?-? *\d{3}-?
                    *-?\d{4}")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Current phone number of the user.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Email
                  <br />
                  <span style={{ color: "#999999" }}>
                    Should be in email format
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Email of the user, JohnDoe
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  NumberOfDependents
                  <br />
                  <span style={{ color: "#999999" }}>
                    RegularExpression(@"[0-9]{1}")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"int"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  No. of dependents (if any) of the user. Enter 0 if none.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  MaritalStatus
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Current marital status of the user. Expected values:
                  <br />
                  S = Single,
                  <br />
                  W = Widowed,
                  <br />
                  D = Divorsed,
                  <br />
                  M= Married
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentStatus
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Current employment status of the user. Expected values:
                  <br />
                  E = Employed,
                  <br />
                  R = Retired,
                  <br />
                  S = Self-Employed,
                  <br />
                  St = Student
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsBusinessEntity = False
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmployerOrBusinessName
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  The name of the employer where the user is currently employed
                  or The company name of the user in case of self employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  OccupationOrComapnyType
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(11), RegularExpression(@"\(?\d{3}\)?-? *\d{3}-?
                    *-?\d{4}")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Occupation of the user or the company type of the company in
                  case of self employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentAddress
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  The official address of the employer or the company.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span> If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentAptOrSuite
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(5)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Int"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Apartment or suite of the employer or the company.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentYearsOfExperience
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Total years of experience in the said occupation or business.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentCountry
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Country of employment or the country where the company or
                  business is registered in case of self employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentState
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  State of employment or the state where the company or business
                  is registered in case of self employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentCity
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  City of employment or the city where the company or business
                  is registered in case of self employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentPhone
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(11), RegularExpression(@"\(?\d{3}\)?-? *\d{3}-?
                    *-?\d{4}")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Phone number of employer or the the company or business
                  registered phone number in case of self employed.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  EmploymentStatus != R AND EmploymentStatus != St
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  EmploymentFax
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Fax of employer or the the company or business registered fax
                  number in case of self employed.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IsTrustedContactPersonAvailable
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"Bool"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  If there is another trusted contact person available. Default
                  value = False
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPName
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Name of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPPhoneNumber
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(11), RegularExpression(@"\(?\d{3}\)?-? *\d{3}-?
                    *-?\d{4}")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Phone number of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPEmail
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Email of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPAddress
                  <br />
                  <span style={{ color: "#999999" }}>StringLength(100)</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Address of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPCountry
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Country of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPState
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  State of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPCity
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(50), RegularExpression(@"^[a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  City of another trusted contact person
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPZip
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(10), RegularExpression(@"^[0-9a-z A-Z]+$")
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Zip of another trusted contact person
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPRelationToAccountHolder
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Relation of another trusted contact person with user
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span>If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TCPDateOfBirth
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"DateTime"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Date of birth of another trusted contact person. For example:
                  24 September 1990.
                  <br />
                  <br />
                  <span style={{ color: "#ff4848" }}>Required: </span> If
                  IsTrustedContactPersonAvailable = True
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  NetWorthExcludingResidence
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the net worth excluding residence i.e
                  <br />
                  1 = $25,000 and under,
                  <br />
                  2 = $25,001 - $50,000,
                  <br />
                  3 = $50,001 - $200,000,
                  <br />
                  4 = $200,001 - $500,000,
                  <br />
                  5 = $500,001 ‐ $1,000,000,
                  <br />6 = over $1,000,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  LiquidNetWorth
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              fieldValidations: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                ></MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the liquid net worth. Expected values i.e
                  <br />
                  1 = $25,000 and under,
                  <br />
                  2 = $25,001 - $50,000,
                  <br />
                  3 = $50,001 - $200,000,
                  <br />
                  4 = $200,001 - $500,000,
                  <br />
                  5 = $500,001 ‐ $1,000,000,
                  <br />6 = over $1,000,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TaxRate
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the tax rate. Expected values i.e
                  <br />
                  1 = 0 - 5,
                  <br />
                  2 = 16 - 25,
                  <br />
                  3 = 26 - 30,
                  <br />
                  4 = 31 - 35,
                  <br />5 = over 35
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  InvestmentObjectives
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the investment objectives. Expected values i.e
                  <br />
                  1 = Active or Day Trading,
                  <br />2 = Short Term Trading
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AnnualExpenses
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the annual expenses. Expected values i.e
                  <br />
                  1 = $50,000 and under,
                  <br />
                  2 = $50,001 - $100,000,
                  <br />
                  3 = $100,001 - $250,000,
                  <br />
                  4 = $250,001 ‐ $500,000,
                  <br />5 = over $500,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SpecialExpenses
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the special expenses. Expected values i.e
                  <br />
                  1 = $50,000 and under,
                  <br />
                  2 = $50,001 - $100,000,
                  <br />
                  3 = $100,001 - $250,000,
                  <br />
                  4 = $250,001 ‐ $500,000,
                  <br />5 = over $500,000
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  LiquidityNeeds
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Values of the liquidity needs. Expected values i.e
                  <br />
                  1 = Very Important,
                  <br />
                  2 = Important,
                  <br />
                  3 = Somewhat important,
                  <br />4 = Does not matter
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  TimeToAchieveFinancialGoal
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value of the time to achieve financial goal. Expected values
                  i.e
                  <br />
                  1 = Under 1 year,
                  <br />
                  2 = 1 - 2,
                  <br />
                  3 = 3 - 5,
                  <br />
                  4 = 6 - 10,
                  <br />
                  5 = 11 - 20,
                  <br />6 = Over 20
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AssetClasses
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"List<AssetClassValue>"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  AssetClassValue's description is given on Other Data Sheet.
                  Knowledge and YearsOfExperience must be greater than before
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  InvestmentRiskTolerance
                  <br />
                  <span style={{ color: "#999999" }}>
                    StringLength(1), ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Value for investment risk tolerance i.e
                  <br />
                  1 = Conservative,
                  <br />
                  2 = Moderately Conservative,
                  <br />
                  3 = Moderate,
                  <br />
                  4 = Moderately Aggressive,
                  <br />5 = Significant Risk
                </MDTypography>
              ),
            },
          ],
        },
        // respObjKey: "signupAccountRouteUrl"
      },
      {
        mainGridId: "iu-ja-signup-otp-api",
        routeUrlId: "signup-otp-data-api-route-url",
        dataFeildId: "signup-otp-data-api-data-fields",
        subHeading: "IU/JA Signup OTP API",
        endPointHeading: "Request Endpoint",
        endPointDesc:
          "<base URL>/API/v1/signup/VerifyOtp?userIdentifierCode=<UserIdentifierCode>&otp=<otp>",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the Signup OTP API is as follows:",
        requestHeaderTable: {
          columns: [
            { Header: "S/N", accessor: "num", align: "left", width: "5%" },
            { Header: "Key", accessor: "key", align: "left", width: "10%" },
            { Header: "Value", accessor: "value", align: "left" },
          ],
          rows: [
            {
              num: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  1
                </MDTypography>
              ),
              key: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Authorization
                </MDTypography>
              ),
              value: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  {"Bearer <token>"}
                </MDTypography>
              ),
            },
          ],
        },
        dataFieldHeading: "Update Request of Signup OTP API",
        dataFieldDesc:
          'This Signup OTP API can also be used to send an update request to make changes in the previously saved data. To use this API as an update API, the user must send the "UserIdentifierCode" data field with the other data fields. This user ID refers to the user whose data needs to be updated.',
        // respObjKey: "signupAccountRouteUrl"
      },
      {
        mainGridId: "iu-ja-all-accounts-api",
        routeUrlId: "all-accounts-api-route-url",
        // dataFeildId: "signup-otp-data-api-data-fields",
        subHeading: "IU/JA All Accounts API",
        subHeadingDesc:
          "The all-accounts API allows the user to get all the accounts created in the system. It provides a way to get and filter the accounts based on application statuses and emails. The email field is a non-required field here.",
        endPointHeading: "Request Endpoint",
        endPointDesc:
          " <base URL>/API/v1/signup/allaccounts?accountapplicationstatus=<status>&accoun temail=<email>",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the All Accounts API is as follows:",
        requestHeaderTable: {
          columns: [
            { Header: "S/N", accessor: "num", align: "left", width: "5%" },
            { Header: "Key", accessor: "key", align: "left", width: "10%" },
            { Header: "Value", accessor: "value", align: "left" },
          ],
          rows: [
            {
              num: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  1
                </MDTypography>
              ),
              key: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Authorization
                </MDTypography>
              ),
              value: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  {"Bearer <token>"}
                </MDTypography>
              ),
            },
          ],
        },
        // dataFieldHeading: "Filter Accounts API",
        // dataFieldDesc: 'The filter accounts API allows the AO user to get all the accounts created in the system. It provides a way to get and filter the accounts based on application statuses, emails, list of identifier codes and date.',
        // respObjKey: "signupAccountRouteUrl"
      },
      {
        mainGridId: "iu-ja-filter-accounts-api",
        routeUrlId: "all-accounts-api-route-url",
        dataFeildId: "signup-otp-data-api-data-fields",
        subHeading: "IU/JA Filter Accounts API",
        subHeadingDesc:
          "The filter accounts API allows the user to get all the accounts created in the system. It provides a way to get and filter the accounts based on application statuses, emails, a list of identifier codes, and dates.",
        endPointHeading: "Request Endpoint",
        endPointDesc: "<base URL>/API/v1/signup/allaccounts",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the Filter Accounts API is as follows:",
        requestHeaderTable: {
          columns: [
            { Header: "S/N", accessor: "num", align: "left", width: "5%" },
            { Header: "Key", accessor: "key", align: "left", width: "10%" },
            { Header: "Value", accessor: "value", align: "left" },
          ],
          rows: [
            {
              num: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  1
                </MDTypography>
              ),
              key: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Authorization
                </MDTypography>
              ),
              value: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  {"Bearer <token>"}
                </MDTypography>
              ),
            },
          ],
        },
        dataFieldHeading: "Data Fields",
        dataFieldDesc:
          "The Filter Accounts API can be called by providing the data fields in the raw JSON body of the request.  ",
        dataFieldTable: {
          columns: [
            {
              Header: "Field Name",
              accessor: "fieldName",
              align: "left",
              width: "15%",
            },
            { Header: "", accessor: "dataType", align: "center", width: "5%" },
            { Header: "Comments", accessor: "comments", align: "left" },
          ],
          rows: [
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AccountApplicationStatuses
                  <br />
                  <span style={{ color: "#999999" }}>
                    ValidateExpectedValues
                  </span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Statuses of the applications to get. Expected values:
                  <br />
                  1 = DRAFT,
                  <br />
                  2 = PENDING,
                  <br />
                  3 = ACCEPTED,
                  <br />4 = REJECTED
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  AccountEmail
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"String"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Email of the applications to get.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SearchStartDateTime
                  <br />
                  <span
                    style={{ color: "#999999" }}
                  >{`SearchStartDateTime < SearchEndDateTime`}</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"DateTime"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Starting Datetime value of the Range to get applications from.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  SearchEndDateTime
                  <br />
                  <span
                    style={{ color: "#999999" }}
                  >{`SearchStartDateTime < SearchEndDateTime`}</span>
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"DateTime"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  Ending Datetime value of the Range to get applications from.
                </MDTypography>
              ),
            },
            {
              fieldName: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  IdentifierCodes
                </MDTypography>
              ),
              dataType: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"List<string>"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              comments: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  List of Identifier Codes (from the Initial APIs) of the
                  applications to get.
                </MDTypography>
              ),
            },
          ],
        },
        // respObjKey: "signupAccountRouteUrl"
      },
      {
        mainGridId: "disclosure-documents-apis-list-all",
        mainHeading: "Disclosure Documents",
        mainHeadingDesc:
          "The Disclosure Documents APIs are designed to get any information related to disclosure documents that must be read and agreed to at the time of account opening. The documents will be updated regularly so the way these APIs should implement is to query the documents each time a new account opening application is started in the system.",
        routeUrlId: "api-opt-documents-list-all-route-url",
        // dataFeildId: "signup-initial-information-api-data-fields",
        subHeading: "List All",
        endPointMethod: "GET",
        endPointHeading: "Request Endpoint",
        endPointDesc: "<base URL>/API/v1/documents/list",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the List All is as follows:",
        respObjKey: "list_all_resp_body",
        requestHeaderTable: {
          columns: [
            { Header: "S/N", accessor: "num", align: "left", width: "5%" },
            { Header: "Key", accessor: "key", align: "left", width: "10%" },
            { Header: "Value", accessor: "value", align: "left" },
          ],
          rows: [
            {
              num: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  1
                </MDTypography>
              ),
              key: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Authorization
                </MDTypography>
              ),
              value: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  {"Bearer <token>"}
                </MDTypography>
              ),
            },
          ],
        },
        // respObjKey: "signupInitialRouteUrl"
      },
      {
        mainGridId: "api-options-list-all-route-url",
        routeUrlId: "get-specific-documents-list-all-route-url",
        // dataFeildId: "signup-initial-information-api-data-fields",
        subHeading: "Get Specific Document ",
        endPointHeading: "Request Endpoint",
        endPointMethod: "GET",
        endPointDesc:
          "<base URL>/API/v1/documents?documentType=<type of the document>",
        requestHeaderNote:
          "Note: Users can send any of the document types that they got from the List All endpoint above. For example: <base URL>/API/v1/documents?documentType=<W9Certification>",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the Get Specific Document API is as follows:",
        requestHeaderTable: {
          columns: [
            { Header: "S/N", accessor: "num", align: "left", width: "5%" },
            { Header: "Key", accessor: "key", align: "left", width: "10%" },
            { Header: "Value", accessor: "value", align: "left" },
          ],
          rows: [
            {
              num: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  1
                </MDTypography>
              ),
              key: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Authorization
                </MDTypography>
              ),
              value: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  {"Bearer <token>"}
                </MDTypography>
              ),
            },
          ],
        },
        dataFieldHeading: "Request Query Parameters",
        dataFieldDesc:
          "The Filter Accounts API can be called by providing the data fields in the raw JSON body of the request.  ",
        dataFieldTable: {
          columns: [
            {
              Header: "S/N",
              accessor: "num",
              align: "left",
              width: "5%",
            },
            { Header: "Key", accessor: "key", align: "center", width: "5%" },
            { Header: "Value", accessor: "value", align: "left" },
          ],
          rows: [
            {
              num: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  1
                </MDTypography>
              ),
              key: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"documentType"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              value: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  AccountTermsConditions
                </MDTypography>
              ),
            },
          ],
        },
        // respObjKey: "signupInitialRouteUrl"
      },
      {
        mainGridId: "api-options",
        mainHeading: "API Options",
        mainHeadingDesc:
          "The API Options APIs are designed to get information about Field Validations. The List All endpoint can be used to get all the options' names, from which any of the option names can be used in the Get Option Details endpoint to get valid values for that particular option.",
        routeUrlId: "documents-list-all-route-url",
        // dataFeildId: "signup-initial-information-api-data-fields",
        subHeading: "List All",
        endPointHeading: "Request Endpoint",
        endPointDesc: "<base URL>/API/v1/ApiOptions",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the List All API is as follows:",
        requestHeaderTable: {
          columns: [
            { Header: "S/N", accessor: "num", align: "left", width: "5%" },
            { Header: "Key", accessor: "key", align: "left", width: "10%" },
            { Header: "Value", accessor: "value", align: "left" },
          ],
          rows: [
            {
              num: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  1
                </MDTypography>
              ),
              key: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Authorization
                </MDTypography>
              ),
              value: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  {"Bearer <token>"}
                </MDTypography>
              ),
            },
          ],
        },
      },
      {
        routeUrlId: "api-opt-get-specific-document-route-url",
        dataFeildId: "documents-get-specific-document-route-url",
        subHeading: "Get Option Details",
        endPointHeading: "Request Endpoint",
        endPointDesc:
          "<base URL>/API/v1/ApiOptions/Details?optionName=<name of option>",
        requestHeader: "Request Header",
        requestHeaderDesc:
          "The route URL along with other request data of the Get Option Details API is as follows:",
        requestHeaderTable: {
          columns: [
            { Header: "S/N", accessor: "num", align: "left", width: "5%" },
            { Header: "Key", accessor: "key", align: "left", width: "10%" },
            { Header: "Value", accessor: "value", align: "left" },
          ],
          rows: [
            {
              num: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  1
                </MDTypography>
              ),
              key: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  Authorization
                </MDTypography>
              ),
              value: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  {"Bearer <token>"}
                </MDTypography>
              ),
            },
          ],
        },
        dataFieldHeading: "Request Query Parameters",
        dataFieldDesc: "",
        respObjKey: "get_options_details",
        dataFieldTable: {
          columns: [
            {
              Header: "S/N",
              accessor: "num",
              align: "left",
              width: "5%",
            },
            { Header: "Key", accessor: "key", align: "center", width: "5%" },
            { Header: "Value", accessor: "value", align: "left" },
          ],
          rows: [
            {
              num: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  1
                </MDTypography>
              ),
              key: (
                <MDTypography
                  component="p"
                  variant="button"
                  color="text"
                  fontWeight="regular"
                >
                  <MDBadge
                    color="success"
                    badgeContent={"optionName"}
                    variant="gradient"
                    size="sm"
                  ></MDBadge>
                </MDTypography>
              ),
              value: (
                <MDTypography
                  component="p"
                  variant="caption"
                  color="text"
                  fontWeight="regular"
                  display="block"
                >
                  ValidGovtIDType
                </MDTypography>
              ),
            },
          ],
        },
        otherData: {
          heading: "Query Response",
          desc: " ",
        },
        // respObjKey: "signupAccountRouteUrl"
      },
    ],
  },

  // General Data Bottom
  General_Data_Bottom: {
    children: [
      {
        sde: true,
        generalMainHeading: "Sample Data Encryption",
        mainGridId: "sample-data-encryption",
        subData: [
          {
            SubHeading: "Encrypting JSON Data",
            SubDesc:
              "The following piece of code can be used to encrypt a JSON body request. Currently, only Account Funding Data APIs are using this type of encryption.",
          },
          {
            SubHeading: "Encrypting Form Data And Attaching Files",
            SubDesc:
              "The following piece of code is used to encrypt form data. Currently, Initial Information APIs and Other Data APIs are using this type of encryption.",
          },
        ],
      },
      {
        sde: true,
        generalMainHeading: "Disclaimer and Confidentiality Notice",
        mainGridId: "disclaimer-and-confidentiality-notice",
        generalDescOne:
          "The information contained in these documents is confidential, privileged, and only for the understanding of the intended recipient and may not be used, published, or redistributed without prior written consent from VCT Technologies LLC.",
        generalDescTwo: [
          {
            valOne:
              "The information is provided with care in these documents, VCT Technologies LLC makes no representations and gives no warranties of whatever nature in respect of these documents, including, but not limited to, the accuracy or completeness of any information, facts, and/or opinions contained therein. VCT Technologies LLC, its subsidiaries, the directors, employees, and agents cannot be held liable for the use of, and reliance on the information provided in these documents.",
          },
        ],
      },
    ],
  },
};

export default accountOpeningApiData;
